document.res_es = {
	// ── PL.tip: la caja con cabecera se construye en JS (antes #{global.tip}) ──
	tipHeader_title: "Consejo",
	// la × del consejo en modo guiado (js/pl/tip.js) — solo aria-label
	tipClose_label: "Cerrar",
	touchRotateHint_body: "Gire la tableta en horizontal: así cabe un panel lateral junto a la página.",
	touchRotateHintClose_label: "Cerrar",
	// ── Touch layer: the tap copy (tablet-support-plan.md §7b, S7) ──
	// js/touch/copy.js reads <key>_touch in place of <key> on a touch device (seam T-16, util.js
	// getRes). Same meaning, the finger's verb; a line that offered Enter/Esc as the other way drops it.
	obTourWlAdd_body_touch: "Toque este botón y elija una lista: la palabra pasa directamente a la seleccionada. Las listas de palabras sirven para reunir exactamente las palabras que quiere aprender y practicar.",
	obTourMyList_body_touch: "Aquí están todas las palabras y expresiones que ha añadido a su lista de palabras. Tóquela para abrirla.",
	obTourBandAdd_body_touch: "Todas las listas tienen uno: pasa palabras de la lista a su bandeja. Tóquelo.",
	obTourBandFive_body_touch: "Toque la flecha pequeña junto al 5 y se eligen cinco palabras al azar.",
	obWlOffer_body_touch: "Ya está todo listo: toque «¡A aprender!» y aprenda sus palabras nuevas.\n\nPero antes de continuar, permítame mostrarle las listas de palabras un poco más de cerca. ¡Hay mucho por descubrir ahí! También podrá hacer el recorrido por las listas más tarde, desde el menú de ayuda {?}.\n\n¿Desea continuar el recorrido?",
	obWlGarden_body_touch: "Aquí crece cada palabra que ha plantado, ordenada según lo bien que la conoce. Toque Mi jardín para abrirlo.",
	obWlLevels_body_touch: "Todas las palabras del diccionario se reparten en listas por nivel, de las más fáciles a las más difíciles. Toque una lista para abrirla y ver sus palabras.",
	obWlTopicPick_body_touch: "Dieciocho listas detrás de una sola fila: comida, viajes, trabajo y las demás. Toque la resaltada para abrirla.",
	obWlTopicWord_body_touch: "Toque una palabra en cualquier lista de palabras para ver su entrada del diccionario. Pruebe con la resaltada.",
	obWlFilter_body_touch: "Toque la lupa para encontrar rápidamente palabras en todas sus listas de palabras.",
	obWlNew_body_touch: "Toque este botón para crear una nueva lista de palabras: reúna ahí las palabras por lección, por canción, por tema, como prefiera.",
	obWlNewUse_body_touch: "La próxima vez que toque {0} junto a una palabra que quiera guardar, podrá enviarla a esta lista.",
	obMeetReveal_body_touch: "Intente adivinar y luego toque el enunciado para ver qué significa.",
	obTourRowOpen_touch: "Toque la palabra para abrir su entrada: ahí está el botón que la lleva a Aprender.",
	obMeetEntry_body_touch: "Cada palabra que conoce viene con una entrada del diccionario completa: significados, gramática, ejemplos y pronunciación. La traducción está arriba; todo lo demás, debajo. Mantenga pulsada una palabra o una etiqueta para ver qué significa.",
	obMeetGotIt_body_touch: "Toque «{0}» cuando haya terminado de leer.",
	obTipExpStart_body_touch: "<p>Toque «¡A aprender!» para conocer sus primeras palabras: elegidas al azar de su nivel para esta primera sesión. Más adelante podrá elegir las palabras que quiera.</p><p>Una cosa más: mientras dura el recorrido, la mayor parte de la aplicación queda a propósito fuera de alcance, para que nada distraiga del camino más sencillo. Después, por supuesto, todo vuelve a estar disponible.</p>",
	obTipExpList_body_touch: "Toque esta lista de palabras del diccionario para abrirla.",
	obTipExpChip_body_touch: "Toque esta letra para abrir la lista de palabras más fácil del diccionario.",
	obTipExpAdd_body_touch: "Este botón añade palabras de la lista abierta a su bandeja de aprendizaje: tóquelo y elija cuántas.",
	obGuideFive_body_touch: "Toque la flecha pequeña y 3 palabras al azar caerán en su bandeja de aprendizaje.",
	obGuideFiveNext_body_touch: "Toque la flecha pequeña y 5 palabras al azar caerán en su bandeja de aprendizaje.",
	obGuideDrill_body_touch: "Toque «¡Empezar el ejercicio!» — un ejercicio breve y cronometrado afianzará estas palabras.",
	obTipSpacePron_body_touch: "Toque el botón del altavoz para escuchar la pronunciación de la palabra. Aparece siempre que la palabra se puede oír.",
	obTipThirsty_body_touch: "Algunas de sus plantas están sedientas. Toque la etiqueta para poner en la bandeja justo esas palabras y darles un riego rápido.",
	learnStudyTerm_tooltip_touch: "Toque para abrir la entrada completa del diccionario de esta palabra",
	learnMeet_reveal_label_touch: "¿Sabe la traducción? Toque aquí para verla",
	learnQ_pickHint_touch: "Toque la tarjeta correcta",
	stopButton_tooltip_touch: "Toque para detener el ejercicio y volver a la página principal",
	phraseBand_pagerRow_tooltip_touch: "Filas {0}–{1} de {2} — toque para saltar",
	startButton_tooltip_touch: "¡Toque para empezar a aprender palabras!",
	practiceDir_mix_tooltip_touch: "Toque ambas direcciones para una sesión mezclada: cada palabra va en el sentido contrario al de la última vez<p/>(el conjunto mantiene su tamaño: una tarjeta por palabra)",
	pauseButton_tooltip_touch: "Toque para pausar el aprendizaje de palabras",
	continueButton_tooltip_touch: "Toque para seguir aprendiendo palabras",
	richTerm_tooltip_touch: "Toque para plegar, o use el botón Atrás del navegador para salir de esta vista",
	revealTerm_tooltip_touch: "Toque para abrir la entrada del diccionario",
	pronDialPlay_hint_touch: "toque para oírlo",
	wlGarden_tooltip_touch: "Todas las palabras que ha tocado de verdad: lo que necesita riego, lo que empezó y lo que está creciendo<p/>Toque la flor para ver todo el jardín",
	wlLevelSort_tooltip_touch: "Orden de esta lista: toque para cambiar",
	wlLevelCompactHint_tooltip_touch: "<p>Doble toque: plegar las filas de niveles en una sola tira.</p><p>Doble toque en el 📖 para desplegar.</p><p>También: menú de cuenta ▸ Ajustes ▸ Ajustes de listas de palabras.</p>",
	wlLevelExpandHint_tooltip_touch: "<p>Doble toque: desplegar, una fila por nivel.</p><p>Doble toque en el 📖 de una fila para volver a plegar.</p><p>Toque una letra para abrir esa lista.</p><p>También: menú de cuenta ▸ Ajustes ▸ Ajustes de listas de palabras.</p>",
	wlVerbCompactHint_tooltip_touch: "<p>Doble toque: plegar las filas de verbos en una sola tira.</p><p>Doble toque en el 📝 para desplegar.</p><p>También: menú de cuenta ▸ Ajustes ▸ Ajustes de listas de palabras.</p>",
	wlVerbExpandHint_tooltip_touch: "<p>Doble toque: desplegar, una fila por lista.</p><p>Doble toque en el icono de una fila para volver a plegar.</p><p>Toque un icono para abrir esa lista.</p><p>También: menú de cuenta ▸ Ajustes ▸ Ajustes de listas de palabras.</p>",
	richTopicHint_tooltip_touch: "(toque para abrir la lista de palabras de este tema)",
	knownToggle_tooltip_touch: "Marcar este significado como ya conocido — los ejercicios lo omiten (toque otra vez para deshacer)",
	exGroup_recalled_tooltip_touch: "Produjo estas palabras al nivel que usted mismo fijó en el control de nivel de exigencia. Toque las palabras para ver o cambiar dónde está ese listón: es lo único que decide en qué grupo cae cada palabra.",
	exGroup_notRecalled_tooltip_touch: "Estas palabras no volvieron al nivel que usted mismo fijó en el control de nivel de exigencia. No se pierde nada y ninguna planta encoge nunca: simplemente vuelven antes. Toque las palabras para ver o cambiar dónde está ese listón.",
	garden_stats_click_hint_touch: "Toque para ver las estadísticas de esta palabra",
	garden_grow_open_touch: "Toque para ver todo su jardín",
	garden_thirsty_tooltip_touch: "Palabras a las que toca riego<p/>Toque para ponerlas en la bandeja de práctica",
	garden_vista_click_hint_touch: "Toque para ver la entrada completa",
	hist_tip_word_touch: "La palabra a la que se refiere esta fila. Toque la fila para ver todo su historial de aprendizaje.",
	hist_ws_tip_word_touch: "La palabra de esta fila. Toque la fila para ver su historial completo.",
	hist_wh_tip_when_touch: "La sesión que ejercitó esta palabra: su día y su hora de inicio. Toque la fila para abrir esa sesión.",
	hist_acc_hard_sub_touch: "menor precisión, entre las palabras mostradas al menos {0} veces: toque una palabra para ver su historial completo",
	// ── end of the tap copy ──
	tipMakeSmall_label: "Reducir las explicaciones",
	tipMakeLarge_label: "Agrandar las explicaciones",
	// ── Onboarding: the guided first session (js/onboarding.js) ──
	obWelcome_title: "¡Bienvenido!",
	obWelcomeLang_label: "Hablo:",
	obLevelRow_label: "Su nivel:",
	obWelcomeBack_tooltip: "Volver a la página de inicio para elegir otro idioma",
	obWelcome_body: "Un breve recorrido guiado: primero conocerá un par de palabras y luego la pestaña Práctica le ayudará a fijarlas de verdad. Solo tres minutos. Sin registro.",
	obLevel_label: "¿Cuánto sabe ya?",
	obLevelA_button: "Empiezo a aprender {0}",
	obLevelB_button: "Puedo mantener una conversación sencilla",
	obLevelC_button: "Me defiendo bien, pero quiero ampliar mi vocabulario",
	obMeet_button: "Recorrido guiado rápido",
	obMeet_loading: "Cargando sus primeras palabras…",
	obExplore_button: "Explorar por mi cuenta",
	obGotIt_button: "Entendido",
	obBeatBed_title: "¡Plantadas!",
	obBeatBed_body: "Sus palabras ya están en su jardín. Mañana estarán sedientas: vuelva para regarlas.",

	// ── Onboarding: the tour that follows the first finished drill (js/onboarding_guide.js) ──
	obTourProgress_title: "Su progreso",
	obTourProgress_body: "Este panel lleva la cuenta con el tiempo: palabras dominadas, precisión alcanzada y cuánto ha estudiado.",
	obTourBack_title: "Fin de este grupo",
	obTourBack_body: "«Volver a Palabras» sale de la sesión y permite elegir qué estudiar a continuación.",
	obTourDict_title: "El diccionario",
	obTourDict_body: "Todo lo que se puede aprender aquí tiene su entrada: abra el Diccionario.",
	// {0} = the language being learned, {1} = a word that IS in the dictionary
	obTourLookup_body: "Escriba una palabra que quiera buscar en {0}, por ejemplo {1}, y pulse Enter.",
	obTourLookup_title: "Buscar una palabra",
	obTourLookupPlain_body: "Escriba una palabra que quiera buscar en {0} y pulse Enter.",
	obTourWlAdd_title: "Añadir a una lista de palabras",
	obTourWlAdd_body: "Haga clic en este botón y elija una lista: la palabra pasa directamente a la seleccionada. Las listas de palabras sirven para reunir exactamente las palabras que quiere aprender y practicar.",
	obTourMyList_title: "Su lista",
	obTourMyList_body: "Aquí están todas las palabras y expresiones que ha añadido a su lista de palabras. Haga clic para abrirla.",
	obTourRowAdd_title: "Llevar a Aprender",
	obTourRowAdd_body: "Este botón lleva la palabra a su bandeja de Aprender, lista para la próxima sesión.",
	obTourBand_title: "Añadir algunas más",
	obTourBand_body: "Con una sola palabra la sesión se queda corta: abra la lista resaltada, la de su nivel, y añada de una vez un puñado de palabras al azar para aprenderlas juntas. Más adelante también podrá elegir cada palabra concreta una por una.",
	obTourBandAdd_title: "El botón Añadir",
	obTourBandAdd_body: "Todas las listas tienen uno: pasa palabras de la lista a su bandeja. Haga clic en él.",
	obTourBandRandom_title: "Que elija la lista",
	obTourBandRandom_body: "«Al azar» saca un puñado variado: la forma más rápida de llenar una sesión.",
	obTourBandFive_title: "Tome 5",
	obTourBandFive_body: "Haga clic en la flecha pequeña junto al 5 y se eligen cinco palabras al azar.",
	obTourBandAppend_title: "Conservar lo que hay",
	obTourBandAppend_body: "Su bandeja ya contiene una palabra. Elija la segunda opción: añade las nuevas y conserva la que ya está.",
	// ── Onboarding: the Word Lists chapter (offered once the first half of the tour ends) ──
	obWlOffer_title: "Listo para aprender",
	obWlOffer_body: "Ya está todo listo: haga clic en «¡A aprender!» y aprenda sus palabras nuevas.\n\nPero antes de continuar, permítame mostrarle las listas de palabras un poco más de cerca. ¡Hay mucho por descubrir ahí! También podrá hacer el recorrido por las listas más tarde, desde el menú de ayuda {?}.\n\n¿Desea continuar el recorrido?",
	obWlOfferNo_button: "No, sigo por mi cuenta",
	obWlOfferYes_button: "Sí, quiero ver las listas de palabras",
	obWlPanel_title: "Sus listas de palabras",
	obWlPanel_body: "Este panel es su biblioteca: listas ya hechas a partir del diccionario y las listas que cree usted.",
	obWlGarden_title: "Mi jardín",
	obWlGarden_body: "Aquí crece cada palabra que ha plantado, ordenada según lo bien que la conoce. Haga clic en Mi jardín para abrirlo.",
	obWlGardenAuto_title: "Se llena solo",
	obWlGardenAuto_body: "Las palabras que está aprendiendo se añaden aquí automáticamente: nunca hay que añadirlas a mano.",
	obWlLevels_title: "Por frecuencia de uso",
	obWlLevels_body: "Todas las palabras del diccionario se reparten en listas por nivel, de las más fáciles a las más difíciles. Haga clic en una lista para abrirla y ver sus palabras.",
	obWlTopics_title: "Por tema",
	obWlTopicPick_body: "Dieciocho listas detrás de una sola fila: comida, viajes, trabajo y las demás. Haga clic en la resaltada para abrirla.",
	obWlTopicWord_title: "Directo a la entrada",
	obWlTopicWord_body: "Haga clic en una palabra en cualquier lista de palabras para ver su entrada del diccionario. Pruebe con la resaltada.",
	obWlFilter_title: "Buscar una palabra",
	obWlFilter_body: "Haga clic en la lupa para encontrar rápidamente palabras en todas sus listas de palabras.",
	obWlFilterBox_title: "Escriba para buscar",
	obWlFilterBox_body: "Escriba unas letras en el campo de búsqueda: se buscan en todas las listas a la vez, y el número junto a una lista indica cuántas de sus palabras coinciden. Haga clic en la lista para verlas. Pruebe con una palabra de una lección que ya haya terminado: seguramente la encuentre en más de una lista.",
	obWlMine_title: "Mi lista",
	obWlMine_body: "⭐ Cada palabra que guarde desde el diccionario va a la lista que elija: «Mi lista» está aquí desde el principio, pero también podrá crear sus propias listas.",
	obWlNew_title: "Cree la suya",
	obWlNew_body: "Haga clic en este botón para crear una nueva lista de palabras: reúna ahí las palabras por lección, por canción, por tema, como prefiera.",
	obWlNewName_title: "Póngale nombre",
	obWlNewName_body: "Escriba el nombre que quiera y pulse Enter.",
	// {0} = the add-to-list icon, inline
	obWlNewUse_title: "Dónde aparecerá",
	obWlNewUse_body: "La próxima vez que haga clic en {0} junto a una palabra que quiera guardar, podrá enviarla a esta lista.",
	obSignReplay_title: "Ahora le toca a usted",
	obSignReplay_body: "<p>Busque cualquier palabra, cree sus propias listas, vea crecer su jardín. Y sobre todo, escriba sus palabras en «Práctica»: lo que usted mismo recuerda es lo que se queda.</p><p>¿Quiere repetir el recorrido? Está aquí, en este menú.</p>",

	obTourQuit_title: "El recorrido sigue activo",
	obTourQuit_body: "Los demás controles están dormidos mientras dura el recorrido guiado. ¿Desea terminar el recorrido y explorar la aplicación por su cuenta? Podrá volver a empezar el recorrido en cualquier momento desde el menú de ayuda {?}.",
	obTourQuitYes_button: "Sí, terminar el recorrido",
	obTourQuitNo_button: "No, seguir con el recorrido",
	obTourQuitRestart_button: "Empezar el recorrido de nuevo",
	obBack_button: "Atrás",
	obContinue_button: "Continuar",
	obDoorPractice_title: "¿Directo a la práctica?",
	obDoorPractice_body: "¿Pasar directamente a la práctica? El recorrido continuará allí.",
	obDoorPracticeStay_button: "No, seguir en el aprendizaje",
	obDoorPracticeGo_button: "Sí, a la práctica",
	obDoorDict_title: "¿Explorar el diccionario?",
	obDoorDict_body: "Esto terminará el recorrido, pero podrá volver a empezarlo en cualquier momento desde el menú de ayuda {?}.",
	obDoorDictStay_button: "Volver",
	obDoorDictGo_button: "Abrir el diccionario",
	// The second line of every card button that carries a recommendation — the quit card's
	// "continue", the welcome card's "meet your first words", the Word Lists offer's "yes".
	obRecommended_hint: "(Recomendado)",

	// ── Onboarding: the entry tour, on the first meet card (js/onboarding_guide.js) ──
	obMeetReveal_title: "Su primera palabra",
	obMeetReveal_body: "Intente adivinar y luego haga clic en el enunciado —o pulse Intro— para ver qué significa.",
	obMeetEntry_title: "La palabra entera",
	obMeetEntry_body: "Cada palabra que conoce viene con una entrada del diccionario completa: significados, gramática, ejemplos y pronunciación. La traducción está arriba; todo lo demás, debajo.",
	// {0} = the meet card's own forward button
	obMeetGotIt_title: "Continuar",
	obMeetGotIt_body: "Haga clic en «{0}» cuando haya terminado de leer.",
	obMeetNext_title: "Su turno",
	obMeetNext_body: "Basta con seguir las instrucciones en pantalla para continuar aprendiendo sus primeras palabras con Parlevi.",

	// ── Onboarding: beacon tips (js/onboarding_tips.js) ──
	obTipExpLearn_title: "Empiece aquí",
	obTipExpLearn_body: "Las palabras nuevas se conocen en la pestaña Aprender. Tome unas cuantas de las listas de palabras de la izquierda para arrancar.",
	obTipExpStart_title: "Conozca sus palabras",
	obTipExpStart_body: "<p>Haga clic en «¡A aprender!» para conocer sus primeras palabras: elegidas al azar de su nivel para esta primera sesión. Más adelante podrá elegir las palabras que quiera.</p><p>Una cosa más: mientras dura el recorrido, la mayor parte de la aplicación queda a propósito fuera de alcance, para que nada distraiga del camino más sencillo. Después, por supuesto, todo vuelve a estar disponible.</p>",
	obTipExpDrill_title: "Ya están listas",
	obTipExpDrill_body: "Sus palabras lo han logrado. Llévelas a Práctica: un ejercicio corto las afianzará.",
	obTipExpList_title: "Abra una lista",
	obTipExpList_body: "Haga clic en esta lista de palabras del diccionario para abrirla.",
	obTipExpChip_body: "Haga clic en esta letra para abrir la lista de palabras más fácil del diccionario.",
	obTipExpAdd_title: "Añada unas palabras",
	obTipExpAdd_body: "Este botón añade palabras de la lista abierta a su bandeja de aprendizaje: haga clic en él y elija cuántas.",
	obTipExpTray_title: "Sus palabras esperan",
	obTipExpTray_body: "Las palabras que eligió están en su bandeja, en la pestaña Aprender, listas cuando usted lo esté.",

	// ── Onboarding: the explore glow guide's menu steps (js/onboarding_guide.js) ──
	obGuideRandom_title: "Que elija la lista",
	obGuideRandom_body: "Aleatorio saca un puñado variado de palabras: la forma más rápida de empezar.",
	obGuideFive_title: "Empiece con 3",
	obGuideFive_body: "Haga clic en la flecha pequeña y 3 palabras al azar caerán en su bandeja de aprendizaje.",
	obGuideFiveNext_title: "Otras 5 más",
	obGuideFiveNext_body: "Haga clic en la flecha pequeña y 5 palabras al azar caerán en su bandeja de aprendizaje.",
	obGuideDrill_title: "Ejercítelas",
	obGuideDrill_body: "Haga clic en «¡Empezar el ejercicio!» — un ejercicio breve y cronometrado afianzará estas palabras.",
	// {0} = the language THIS card is answered in (it changes card by card in a Mix session).
	obGuideType_title: "Su turno",
	obGuideType_body: "Escriba aquí la traducción al {0} y pulse Enter.",
	// (onboarding ob* keys deliberately absent — ES falls back to English per getRes)
	// ── Modo de aprendizaje (la pestaña Aprender) ──
	learnEmpty_message: "Su bandeja de aprendizaje está vacía.",
	quickStart_line: "Tome palabras de las Listas de palabras de la izquierda — o elija aquí mismo {0} palabras al azar:",
	quickStart_count_tooltip: "Cuántas palabras añade cada botón",
	quickStart_exhausted_tooltip: "Aquí ya está todo estudiado — elija otras en las Listas de palabras",
	learnStartButton_label: "¡A aprender!",
	learnStartButton_tooltip: "Conozca las palabras nuevas con calma — sin reloj ni presión",
	learnClear_tooltip: "Vaciar la bandeja de aprendizaje",
	learnRelearn_button: "Reaprender",
	learnRelearn_tooltip: "Ejercitar otra vez estas palabras listas — la escalera vuelve a empezar y siguen «listas»",
	learnBackToTray_label: "← volver a las palabras",
	learnGuided_dots: "Práctica · 6 rondas por palabra",
	learnNew_badge: "nueva",
	learnRow_progress_tooltip: "Ya empezada — la escalera sigue donde se quedó",
	learnStudyTerm_tooltip: "Haga clic para abrir la entrada completa del diccionario de esta palabra",
	learnMeet_reveal_label: "¿Sabe la traducción? Haga clic aquí o pulse Enter para verla",
	learnMeet_gotIt_label: "Entendido →",
	learnMeet_fromVerb_label: "del verbo",
	learnQ_meaning: "¿Qué significa?",
	learnQ_pickWord: "Elija la palabra para:",
	learnQ_lookalike: "Fíjese bien y elija la que significa:",
	learnQ_whoWhen: "¿Quién y cuándo?",
	learnQ_whoWhenHint: "el pronombre se omite a propósito — la terminación dice quién",
	learnOpt_none: "Ninguna de estas",
	learnNone_taught: "Correcto: la palabra no estaba entre ellas.",
	learnQ_phraseMeaning: "¿Qué significa {0} aquí?",
	learnQ_pickPhrase: "Elija la expresión para:",
	learnQ_pickGap: "¿Qué palabra completa la frase?",
	learnQ_typeGapHint: "escriba las primeras {0} letras de la palabra que falta — se completará sola",
	learnQ_typeFullGapHint: "escriba solo la palabra que falta — al segundo fallo en una letra se revela",
	learnQ_start: "¿Cómo empieza?",
	learnQ_typeHint: "escriba las primeras {0} letras — la palabra se completará sola",
	learnQ_letterHint: "pista: empieza por {0}",
	learnQ_letterHintSubst: "pista: empieza por {0} — también vale escribir “{1}”",
	learnQ_hearHint: "pista: escuche — aquí está la palabra",
	learnQ_change: "¿Qué cambia?",
	learnQ_changeHint: "escriba la parte que cambia en cada forma",
	learnQ_typeFull: "Ahora escriba la palabra entera",
	learnQ_typeFullHint: "escríbala de memoria — al segundo fallo en una letra se revela",
	learnQ_repeatWord: "Repita la palabra",
	learnQ_hear: "¿Qué escuchó?",
	learnQ_pickHint: "Haga clic en la tarjeta correcta o escriba su número",
	learnFeedback_correct: "¡Correcto!",
	learnFeedback_wrong: "Casi",
	learnFeedback_retry: "tendrá otro intento",
	learnMiss_settling: "Aún se está asentando — volveremos a ella en un momento.",
	learnMiss_continue: "Continuar →",
	learnSpace_tooltip: "Enter",
	learnReady_toast: "Ya se puede ejercitar {0}",
	learnRecap_head: "{0} palabras nuevas conocidas",
	learnRecap_met: "palabras conocidas",
	learnRecap_ready: "listas para ejercitar",
	learnRecap_time: "tiempo",
	learnRecap_bridge: "Quedarán esperando en la bandeja de Práctica — ejercitarlas las fija para siempre.",
	learnRecap_drillNow: "¡A la Práctica! →",
	learnRecap_back: "Volver a Aprender",
	learnNudge_message: "Palabras totalmente nuevas aquí: {0} — un primer vistazo en Aprender hace que la práctica sea muy distinta.",
	learnNudge_action: "Aprenderlas primero",
	learnError_message: "No se pudo iniciar la sesión de aprendizaje",

	proceed: "¿Continuar?",
	error: "Lo sentimos, se ha producido un error.\nPruebe a recargar la página",
	stopButton_tooltip: "Haga clic para detener el ejercicio y volver a la página principal",
	langTo_tooltip: "Seleccione el idioma que quiere estudiar",
	langFrom_tooltip: "Seleccione su propio idioma o uno que ya conozca",
	browserTitle_main: "Aprender {0} — {1}",
	enDialectUs_tooltip: "Inglés estadounidense — la voz que se escucha, la transcripción principal y el acento con el que se evalúa su pronunciación",
	enDialectUk_tooltip: "Inglés británico — la voz que se escucha, la transcripción principal y el acento con el que se evalúa su pronunciación",
	operationCannotComplete_message: "No se puede completar la operación",

	myList_create_tooltip: "Crear una nueva lista de palabras",
	// ── Dictionary direction: the DE⇄EN toggle and the reverse (EN → DE) hit list ──
	// {0} = the language the typed word is expected to be in. Both directions are as-you-type: the
	// forward seek walks the German dictionary, the reverse one walks the tape of English keys
	// (design §9). Enter then focuses the one word, which is what "press Enter" used to mean here.
	lookupField_placeholder_forward: "Escriba una palabra en {0} para ver su entrada",
	lookupField_placeholder_reverse: "Escriba una palabra en {0} para ver las palabras que la traducen",
	dictDir_forward_tooltip: "Buscar una palabra en {0} — el idioma que aprende (Alt+1)",
	dictDir_reverse_tooltip: "Buscar una palabra en {0} — ver las palabras en {1} que la traducen (Alt+2)",
	reverse_intro_message: "Escriba una palabra en {0} para ver las palabras en {1} que la traducen.",


	startButton_label: "¡Empezar el ejercicio!",
	startButton_tooltip: "¡Haga clic para empezar a aprender palabras!",
	startButton_noWords_message: "No se seleccionaron palabras para el ejercicio.\nAbra una lista de palabras a la izquierda y use «Añadir a Práctica».",
	connUpdating: "Parlevi se está reiniciando. Espere un minuto, por favor.",
	connLost: "Se perdió la conexión. Sus respuestas están guardadas y se enviarán cuando vuelva.",
	connNoNewExercise: "Parlevi se está reiniciando. Vuelva a intentarlo dentro de un minuto, por favor.",
	revealWord_label: "Mostrar la palabra",
	revealWord_tooltip: "Ver la respuesta de esta palabra",
	startButton_wordsInExercise: "Palabras para un ejercicio:",
	// ── Dirección de la práctica (par de flechas + corchete "mix" + altavoz, en la banda Start) ──
	// Las caras de los botones se construyen con los códigos de idioma ("EN → DE") y no se
	// traducen; aquí va la tarea. {0} = el idioma en el que se escribe.
	practiceDir_forward_tooltip: "Se ve el significado: escriba la palabra en {0}<p/>[ambas direcciones pulsadas = mezcla]",
	practiceDir_reverse_tooltip: "Se ve la palabra: escriba qué significa en {0}<p/>[ambas direcciones pulsadas = mezcla]",
	practiceDir_mix_label: "mezcla",
	practiceDir_mix_tooltip: "Haga clic en ambas direcciones para una sesión mezclada: cada palabra va en el sentido contrario al de la última vez<p/>(el conjunto mantiene su tamaño: una tarjeta por palabra)",
	practiceDir_mixOff_tooltip: "Una sesión mezclada requiere práctica de palabra completa (una tarjeta por palabra)",
	practiceDir_audio_tooltip: "Pista sonora: oiga la palabra en vez de leer el significado<p/>Se combina con cualquier dirección",
	practiceDir_locked_tooltip: "Es la dirección que usa el ejercicio en curso<p/>Deténgalo para cambiarla",
	// Combined tray view only: distinct words vs total drillable senses ({0} = words, {1} = meanings).
	trayCount_wordsAndMeanings: "{0} palabras · {1} significados",
	number_of_words_remaining: "El número de palabras que quedan en el ejercicio actual",
	pauseButton_label: "Pausar ejercicio",
	pauseButton_tooltip: "Haga clic para pausar el aprendizaje de palabras",
	continueButton_label: "Reanudar ejercicio",
	continueButton_tooltip: "Haga clic para seguir aprendiendo palabras",
	practiceAgainButton_label: "¡Practicar otra vez!",
	practiceAgainButton_tooltip: "Repita el mismo conjunto: ahora las palabras deberían salir al primer intento",
	backToWordsButton_label: "Volver a palabras",
	backToWordsButton_sub: "elegir otro conjunto",
	stopButton_label: "Detener ejercicio",
	stopButton_sub: "(y volver a la página principal)",
	undo_label: "Deshacer",
	// The message box's only button (js/msgbox.js). English-only on purpose: getRes falls back
	// to this file, and "OK" is the value in every one of the six locales (see i18n/global*.properties).
	msgOk_button: "OK",
	clearTray_button: "Vaciar",
	clearTray_tooltip: "Vaciar la bandeja de práctica<p/>(Deshacer la restaura)",
	lastFinish_label: "Última sesión de práctica",
	lastFinish_tooltip: "Mostrar de nuevo la última pantalla de práctica terminada",
	trayCapped_message: "Una bandeja admite como máximo {0} palabras: recortada a {2} de {1}. Ejercite esas primero y luego añada el resto.",
	practiceEmpty_message: "Su bandeja de práctica está vacía.",
	noWords_message: "Lo sentimos, aún no hay palabras para esta selección",
	dict_notReady_message: "El diccionario aún se está cargando — un momento…",
	// The flag + language code are prepended as markup, so these carry only the tail: "🇬🇧 EN" + …
	reverse_head_one: "palabra · 1 coincidencia",
	reverse_head_many: "palabra · {0} coincidencias",
	reverse_empty_message: "No hay entrada para «{0}»",
	reverse_fallback_message: "No hay entrada para «{0}» — se muestran resultados de",
	reverse_seeAlso_label: "véase también:",
	reverse_phrases_label: "En expresiones ({0})",
	chooseLangTo_label: "Elegir…",
	chooseLangTo_message: "Elija un idioma para aprender",
	noData_message: "El servidor no devolvió datos",
	wlLabel: "Listas de palabras",
	wlAddPick_label: "Añadir a…",
	wlAddPickNew_label: "Nueva lista…",
	richTerm_tooltip: "Haga clic para plegar, o pulse Esc / el botón Atrás del navegador para salir de esta vista",
	revealTerm_tooltip: "Haga clic para abrir la entrada del diccionario; Esc vuelve a la tarjeta",
	richEmpty_none: "Todavía no hay entrada del diccionario para esta palabra.",
	richEmpty_failed: "No se pudo cargar la entrada del diccionario. Compruebe su conexión e inténtelo de nuevo.",
	sound_tooltip: "Sonido<p/>[Atajo: Espacio]",

	pronMic_tooltip: "Practique la pronunciación<p/>Abre la tarjeta de práctica: mantenga pulsado el micrófono y hable",
	pronHold_tooltip: "Mantenga pulsado y hable; suelte al terminar",
	pronClose_tooltip: "Cerrar",
	pronBest_label: "mejor",
	pronDialRecognition_label: "Comprensible",
	pronDialAccent_label: "Como nativo",
	pronDialLegend_label: "anillo exterior = este intento · centro = su mejor marca",
	pronDialRecLast_tooltip: "Este intento: cuánto de lo dicho entendería un oyente: {0}",
	pronDialRecBest_tooltip: "Su mejor marca aquí en comprensión: {0}",
	pronDialAccLast_tooltip: "Este intento: cuánto se acercó el sonido al de un hablante nativo: {0}",
	pronDialAccBest_tooltip: "Su mejor marca aquí en sonido nativo: {0}",
	pronDialNone_tooltip: "Aún no se ha dicho nada aquí",
	pronDialNoBest_tooltip: "Aún no hay mejor marca registrada",
	pronDialPlay_hint: "haga clic para oírlo",
	pronNoRecording_message: "Sin grabación: su voz se conserva solo hasta que se cierra la página.",
	pronHint_hold: "mantenga pulsado para hablar; suelte al terminar",
	pronHint_recording: "escuchando…",
	pronHint_scoring: "evaluando…",
	pronSoundedLike_tip: "sonó como /{0}/ donde corresponde /{1}/",
	pronOmitted_tip: "esta palabra no se oyó",
	pronDiagHeard_text: "se oyó: «{0}»",
	pronDiagEarHeard_text: "un oyente que no sabía qué esperar oyó: “{0}”",
	pronDiagPatient_text: "un oyente paciente le entiende aquí; a uno normal le cuesta",
	pronDiagMissed_text: "no se entendió: {0}",
	pronDiagSilence_text: "no se oyó nada en esta grabación",
	pronDiagSound_text: "sonido más débil: /{0}/ en “{1}”",
	pronDiagSoundOnly_text: "sonido más débil: /{0}/",
	pronDiagPart_text: "parte más débil: “{0}” en “{1}”",
	pronDiagPartOnly_text: "parte más débil: “{0}”",
	pronDiagWord_text: "palabra más débil: “{0}”",
	pronExpPartial_text: "faltó una parte por decir",
	pronExpPauses_text: "pausas largas entre las palabras",
	pronExpFlat_text: "la entonación se mantuvo plana",
	pronSilent_message: "Esa grabación está en silencio. Puede que el micrófono esté silenciado o apagado.",
	pronNoMic_message: "Este navegador no puede acceder aquí a un micrófono.",
	pronRefusalCap_message: "Se agotó el cupo de práctica de esta semana. Se repone una semana después de cada intento.",
	pronRefusalUnavailable_message: "La evaluación de la pronunciación no está disponible en este idioma.",
	pronRefusalAudio_message: "No se oyó nada en esa grabación.",
	pronRefusalNoWord_message: "Esta palabra ya no está en el diccionario.",
	pronRefusalProvider_message: "Esta vez no llegó la puntuación.",
	hist_wh_chart_spoken: "Pronunciación",
	hist_wh_tip_chart_spoken: "Cada vez que ha dicho esta palabra en voz alta. Un punto por intento, puntuado según su sonido más débil; la línea es su mejor resultado hasta ahora.",
	wlLoad_error_message: "No se pueden cargar sus listas de palabras",
	wlDelete_error_message: "No se puede eliminar la lista de palabras",
	wlRename_tooltip: "Renombrar esta lista de palabras",
	wlDelete_tooltip: "Eliminar esta lista de palabras",
	wlNoWords_message: "No hay palabras seleccionadas",
	wlDeleteWords_tooltip: "Eliminar las palabras seleccionadas de esta lista de palabras",
	wlCopyWords_tooltip: "Copiar las palabras seleccionadas a otra lista de palabras",
	wlCopyNoLists_message: "Solo tiene una lista de palabras: cree otra primero y luego copie en ella las palabras seleccionadas",
	wlDeleteWords_error_message: "No se pueden eliminar palabras de la lista de palabras",
	wlCannotLoadWords_error_message: "No se pueden cargar las palabras de la lista de palabras",
	wlCannotDeleteWord_error_message: "No se puede eliminar la palabra de la lista de palabras",
	wlCopyWords_error_message: "No se pueden copiar las palabras a otra lista de palabras",
	wlAddNoWordList_error_message: "No se puede añadir la palabra a una lista de palabras: no hay ninguna lista de palabras seleccionada",
	wlAdd_error_message: "No se puede añadir la palabra a una lista de palabras",
	wlVerbs_label: "Formas verbales",
	wlVerbs_tooltip: "Verbos irregulares, ejercitados en una tarjeta por verbo, con todas sus formas juntas",
	wlConjugation_label: "Conjugación",
	wlConjugation_tooltip: "Verbos: se ejercita una forma conjugada cada vez",
	wlVerbsNoForms_message: "No se pudo preparar ninguna forma para ese verbo",
	wlVerbsTruncated_message: "Se añadieron los primeros {0} de {1} verbos; añada el resto en otra tanda",
	wlVerbsExpand_error_message: "No se pueden preparar las formas verbales",
	wlTypedPhrases_label: "Expresiones que escribí",
	wlTypedPhrases_tooltip: "Expresiones que ha escrito y que aún no están en nuestro diccionario, visibles solo para usted. Las nuevas llegan aquí automáticamente",
	wlTypedRemove_tooltip: "Quitar de este registro; las copias de sus listas se conservan",
	wlGarden_label: "Mi jardín",
	wlDefault_label: "Mi lista",
	wlGarden_tooltip: "Todas las palabras que ha tocado de verdad: lo que necesita riego, lo que empezó y lo que está creciendo<p/>Haga clic en la flor para ver todo el jardín",
	wlGardenNeedsWater_tooltip: "A {0} palabras les toca riego desde hace tiempo<p/>Abra Mi jardín para verlas",
	wlGardenWatered_tooltip: "Nada necesita riego ahora mismo: todo el jardín está al día",
	wlGardenDifficult_label: "Palabras difíciles",
	wlGardenWatering_label: "Necesitan riego",
	wlGardenProgress_label: "Aprendiendo",
	wlGardenReady_label: "Listas para practicar",
	wlGardenGrowing_label: "Creciendo",
	wlGardenSetAside_label: "Apartadas",
	wlGardenDifficult_tooltip: "Palabras que se le están resistiendo: ejercite cada una en 3 días distintos y saldrá de esta lista",
	wlGardenWatering_tooltip: "A estas palabras ya les tocaba riego: riéguelas ahora para que sigan creciendo",
	wlGardenProgress_tooltip: "Ha empezado estas palabras en Aprender, pero aún no las ha terminado",
	wlGardenReady_tooltip: "Estas palabras ya se han aprendido; ahora necesitan práctica",
	wlGardenGrowing_tooltip: "Estas palabras están plantadas y aún no les toca: la insignia cuenta los días hasta su próxima práctica",
	wlGardenSetAside_tooltip: "Palabras apartadas: descansan aquí, conservando todo lo aprendido, hasta que se las despierte",
	wlGardenEmpty_message: "Aquí todavía no hay nada: aprenda o practique una palabra y aparecerá en su jardín",
	wlGardenSecEmpty_tooltip: "Ahora mismo no hay nada en esta sección",
	wlGardenContinueLearn_label: "Seguir con el aprendizaje",
	wlGardenAll_disabled_tooltip: "Demasiadas palabras para añadir de una vez (máx. {0}): use Aleatorio",
	wlGardenUseSections_note: "Cada sección significa algo distinto: añada desde la cabecera de cada sección.",
	wlLevelA_label: "Elemental",
	wlLevelB_label: "Principiante",
	wlLevelC_label: "Intermedio",
	wlLevelD_label: "Avanzado",
	wlLevelE_label: "Experto",
	wlLevelA_tooltip: "Las 1000 palabras más frecuentes · ≈ MCER A1",
	wlLevelB_tooltip: "Palabras 1001–4000 · ≈ MCER A2",
	wlLevelC_tooltip: "Palabras 4001–12.000 · ≈ MCER B1",
	wlLevelD_tooltip: "Palabras 12.001–24.000 · ≈ MCER B2",
	wlLevelE_tooltip: "Más allá de las 24.000 palabras más frecuentes · ≈ MCER C1–C2",
	// CEFR band slots. The codes are international, so every locale carries them unchanged —
	// genuine identity, not an untranslated placeholder (BundleParityTest guards the key set).
	wlLevelA1_label: "A1",
	wlLevelA2_label: "A2",
	wlLevelB1_label: "B1",
	wlLevelB2_label: "B2",
	wlLevelC1_label: "C1",
	wlLevelC2P_label: "C2+",
	wlLevelA1_tooltip: "Nivel MCER A1: comprender y usar expresiones cotidianas y frases muy sencillas",
	wlLevelA2_tooltip: "Nivel MCER A2: comprender expresiones frecuentes sobre temas cotidianos: familia, compras, trabajo, entorno",
	wlLevelB1_tooltip: "Nivel MCER B1: seguir las ideas principales de textos y discursos claros sobre temas conocidos",
	wlLevelB2_tooltip: "Nivel MCER B2: comprender las ideas principales de textos complejos e interactuar con cierta fluidez",
	wlLevelC1_tooltip: "Nivel MCER C1: comprender una amplia variedad de textos largos y exigentes y usar la lengua con flexibilidad",
	wlLevelC2P_tooltip: "Nivel MCER C2: comprender sin esfuerzo casi todo lo que se oye o se lee, además de palabras raras y especializadas más allá de la escala MCER",
	// Plain-language band names — keys must exist in every locale; real translations exist in
	wlLevelA1_name: "Principiante",
	wlLevelA2_name: "Elemental",
	wlLevelB1_name: "Intermedio",
	wlLevelB2_name: "Intermedio alto",
	wlLevelC1_name: "Avanzado",
	wlLevelC2P_name: "Dominio",
	wlLevelSortAlpha_label: "Alfabético",
	wlLevelSortFreq_label: "Por frecuencia de uso",
	wlLevelSort_tooltip: "Orden de esta lista: haga clic para cambiar",
	wlLevelCompactHint_tooltip: "<p>Doble clic: plegar las filas de niveles en una sola tira.</p><p>Doble clic en el 📖 para desplegar.</p><p>También: menú de cuenta ▸ Ajustes ▸ Ajustes de listas de palabras.</p>",
	wlLevelExpandHint_tooltip: "<p>Doble clic: desplegar, una fila por nivel.</p><p>Doble clic en el 📖 de una fila para volver a plegar.</p><p>Haga clic en una letra para abrir esa lista.</p><p>También: menú de cuenta ▸ Ajustes ▸ Ajustes de listas de palabras.</p>",
	wlLevelStripCount_tooltip: "Palabras del diccionario para este par de idiomas",
	wlVerbCompactHint_tooltip: "<p>Doble clic: plegar las filas de verbos en una sola tira.</p><p>Doble clic en el 📝 para desplegar.</p><p>También: menú de cuenta ▸ Ajustes ▸ Ajustes de listas de palabras.</p>",
	wlVerbExpandHint_tooltip: "<p>Doble clic: desplegar, una fila por lista.</p><p>Doble clic en el icono de una fila para volver a plegar.</p><p>Haga clic en un icono para abrir esa lista.</p><p>También: menú de cuenta ▸ Ajustes ▸ Ajustes de listas de palabras.</p>",
	wlVerbStripCount_tooltip: "Verbos de ambas listas para este par de idiomas",
	wlTopics_label: "Temas",
	wlTopics_tooltip: "El diccionario por situaciones: elija un tema para abrir su lista de palabras",
	wlTopicsPick_label: "Elija un tema",
	wlTopicsEmpty_message: "Todavía no hay temas para este par de idiomas",
	richTopicHint_tooltip: "(haga clic para abrir la lista de palabras de este tema)",
	topic_study_label: "Estudios y educación",
	topic_travel_label: "Viajes y transporte",
	topic_food_label: "Comida y bebida",
	topic_health_label: "Salud y cuerpo",
	topic_sport_label: "Deporte",
	topic_fashion_label: "Moda y apariencia",
	topic_family_label: "Familia y relaciones",
	topic_work_label: "Trabajo y carrera",
	topic_politics_label: "Política y sociedad",
	topic_home_label: "Casa y hogar",
	topic_money_label: "Compras y dinero",
	topic_nature_label: "Naturaleza, clima y medio ambiente",
	topic_animals_label: "Animales",
	topic_tech_label: "Tecnología e Internet",
	topic_media_label: "Medios y comunicación",
	topic_culture_label: "Cultura y entretenimiento",
	topic_feelings_label: "Emociones y carácter",
	topic_law_label: "Derecho y delitos",
	wlAddPractice_button: "Añadir a Práctica",
	wlAddLearn_button: "Añadir a Aprender",
	wlAddMenuHeader_label: "Añadir palabras a la bandeja de Práctica",
	wlAddMenuHeaderLearn_label: "Añadir palabras a la bandeja de Aprendizaje",
	wlMenuAll_label: "Todas",
	wlMenuMax_label: "Máx. (primeras {0})",
	wlMenuSelected_label: "Seleccionadas",
	wlMenuRandom_label: "Al azar",
	wlMenuCountEdit_tooltip: "Cambiar el número de palabras",
	trayReplace_label: "Reemplazar en la bandeja {0}",
	trayAppend_label: "Añadir a la bandeja {0}",
	trayReplace_math: "(−{0} : +{1})",
	trayAppend_math: "({0} + {1} → {2})",
	trayReplace_tooltip: "Descartar las {0} palabras ya puestas en la bandeja y ejercitar estas {1} en su lugar",
	trayAppend_tooltip: "Conservar las {0} palabras ya puestas en la bandeja y añadir estas {1} — {2} en total",
	trayAppendUpTo_math: "({0} + hasta {1})",
	trayAppendUpTo_tooltip: "Conservar las {0} palabras ya puestas en la bandeja y añadir hasta {1} más — las que ya estén en la bandeja no se añadirán dos veces"
		+ " — las que ya estén en la bandeja no se añadirán dos veces",
	trayNothingNew_tooltip: "Las {0} ya están en la bandeja — no hay nada que añadir",
	trayReplaceVerbs_tooltip: "Descartar lo que hay en la bandeja y ejercitar estas formas verbales en su lugar (cada verbo se convierte en varias tarjetas, así que el número se sabe al expandirlas)"
		+ " (cada verbo da varias tarjetas; el número se sabe al desplegarlas)",
	trayAppendVerbs_tooltip: "Conservar lo que hay en la bandeja y añadirle estas formas verbales (cada verbo se convierte en varias tarjetas, así que el número se sabe al expandirlas)"
		+ " (cada verbo da varias tarjetas; el número se sabe al desplegarlas)",
	trayFull_tooltip: "La bandeja ya tiene su máximo de {0} palabras — reemplácela o quite algunas primero",
	trayDest_practice: "Práctica",
	trayDest_learn: "Aprender",
	trayAddLearn_tooltip: "Añadir a Aprender",
	trayAddPractice_tooltip: "Añadir a Práctica",
	trayMoveLearn_tooltip: "Mover a Aprender",
	trayMovePractice_tooltip: "Mover a Práctica",
	trayAlreadyStaged_toast: "Ya está en la bandeja {0}",
	wlMove_label: "Mover a…",
	wlCopy_label: "Copiar a…",
	wlSelected_label: "seleccionadas",
	wlEmptyList_message: "Aún no hay palabras aquí — añada palabras desde el Diccionario o desde otras listas de palabras",
	wlNewListPlaceholder: "Nombre de la nueva lista…",
	wlFilterPlaceholder: "Filtrar palabras…",
	wlxGlobalFilter_placeholder: "Buscar una palabra en todas las listas…",
	wlxGlobalFilter_tooltip: "Buscar en todas las listas de palabras",
	wlNoMatch_message: "Ninguna palabra coincide con el filtro",
	wlCheckAll_tooltip: "Seleccionar todas las palabras",
	wlGardenSecCheckAll_tooltip: "Seleccionar todas las palabras de esta sección",
	wlWordCount_tooltip: "Número de palabras de esta lista",
	wlRowPractice_tooltip: "Añadir esta palabra a la bandeja de Práctica",
	wlRowLearn_tooltip: "Añadir esta palabra a la bandeja de Aprendizaje",
	wlRowMoveCopy_tooltip: "Mover o copiar esta palabra a otra lista de palabras",
	wlRowRemove_tooltip: "Quitar esta palabra de la lista",
	wlRowPark_tooltip: "Aparte esta palabra: deja de salir en la práctica y conserva todo lo aprendido hasta que la despierte. La encontrará en Mi jardín, en la franja «Apartadas» del final",
	wlRowWake_tooltip: "Despertar esta palabra: vuelve a la práctica desde donde se quedó",
	wlRowUnmarkDifficult_tooltip: "Quitar esta palabra de Palabras difíciles",
	wlRowDifficultMarks_tooltip: "Practicada {0} de {1} días — ejercítela {1} días distintos y saldrá de esta lista",
	wlRowDifficultHeld_tooltip: "Practicada {0} días — los tres días ya están, pero la última práctica volvió a señalar esta palabra. Saldrá tras la primera que no lo haga.",
	wlRowDifficultStuck_tooltip: "Practicada {0} días y aún se la sigue señalando — puede que esta necesite reaprenderse más que ejercitarse. Apártela o siga adelante: saldrá tras la primera práctica que no la señale.",
	wlRowParkFailed_error_message: "No se puede apartar esta palabra",
	trayParkNotStarted_message: "Esta palabra aún no se ha practicado, así que no hay nada que apartar — basta con quitarla de la bandeja",
	trayRemove_tooltip: "Quitar esta palabra de la bandeja",
	scrollUp_tooltip: "Subir",
	scrollDown_tooltip: "Bajar",
	knownToggle_tooltip: "Marcar este significado como ya conocido — los ejercicios lo omiten (haga clic otra vez para deshacer)",
	wlSort_tooltip: "Ordenar sus listas (las listas de palabras que ha creado usted)",
	wlSortNewest_label: "Más recientes",
	wlSortOldest_label: "Más antiguas",
	wlSortAlpha_label: "Alfabético",
	wlSortSize_label: "Por tamaño",
	wlBasket_tooltip: "Listas eliminadas recientemente (papelera)",
	wlBasketTitle_label: "Eliminadas hace poco",
	wlBasketEmpty_button: "Borrar todo para siempre",
	wlBasketEmpty_message: "La papelera está vacía",
	wlRestore_button: "Restaurar",
	wlRestore_tooltip: "Restaurar esta lista",
	wlDeleteForever_tooltip: "Borrar definitivamente — no se puede deshacer",
	tzDetected_text: "Detectada",
	settingsTimeZone_tooltip: "Detectada desde su navegador — todo lo que la aplicación llama «hoy» se cuenta con este reloj.<p>Cámbiela solo si es incorrecta o si prefiere mantener el calendario de casa mientras viaja.",
	settingsDayStart_tooltip: "Cuándo empieza su nuevo día.<p>Con el valor predeterminado de las 03:00, una sesión a la 1 de la madrugada cuenta aún como la noche anterior — practicar hasta tarde no debe costar una racha — y el repaso después de dormir es ya el día siguiente. Ponga 00:00 para una medianoche estricta.",
	signupOptional_tooltip: "El registro es opcional.<p> Pero al registrarse, sus listas de palabras y sus ajustes quedan guardados y disponibles desde cualquier dispositivo",
	tsVerbForms_hint: "verbo irregular — {0} formas",
	tsWhichVerb_question: "¿De qué verbo es esta forma?",
	tsWhichVerb_hint: "(vale cualquiera de los significados del verbo)",
	tsListToSound: "Escuche — y luego escriba la traducción al {0}",
	tsWordNotRetrieved: "No se pudieron cargar las palabras",
	tsAnswerNotSet: "No se pudo preparar la respuesta",
	tsYouDoneIt: "¡Muy bien!",
	tsCounterIsZero: "El contador está en cero",
	tsWrong: "No es del todo correcto",
	tsBestAttempt_label: "su mejor intento",
	//Wrong-answer tier phrases (wrong_feedback.js): tier 1 = way off ... tier 5 = almost right.
	tsWrongT1_1: "Sí, esta es difícil… con calma",
	tsWrongT1_2: "Es de las duras — sin prisa",
	tsWrongT1_3: "Palabra complicada — siga con ella",
	tsWrongT2_1: "Todavía no — siga probando",
	tsWrongT2_2: "Pruebe otra vez",
	tsWrongT2_3: "Esta le va a salir",
	tsWrongT3_1: "Caliente, caliente…",
	tsWrongT3_2: "Va por buen camino",
	tsWrongT3_3: "Va mejorando — siga así",
	tsWrongT4_1: "¡Cerca!",
	tsWrongT4_2: "¡Casi lo tiene!",
	tsWrongT4_3: "¡Poco le falta!",
	tsWrongT5_1: "¡Ya casi!",
	tsWrongT5_2: "¡Por muy poco!",
	tsWrongT5_3: "¡Uy — por un pelo!",
	tsSound_tooltip: "Escuchar",
	tsReady_tip: "Coloque el cursor aquí y pulse Enter para pasar a la siguiente palabra del ejercicio",
	tsSelfKnow: "Lo entiendo",
	tsSelfDontKnow: "No lo entiendo",
	tsSelfRight: "Acerté",
	tsSelfWrong: "Me equivoqué",
	tsTypeTranslation_tip: "Escriba aquí la traducción correcta al {0}",
	tsTypeWord_tip: "Escriba aquí la palabra correcta en {0}",
	obGuideTypeWord_body: "Escriba aquí la palabra en {0} y pulse Enter.",
	obTipSpacePron_title: "Escuche cómo suena",
	obTipSpacePron_body: "Haga clic en el botón del altavoz para escuchar la pronunciación de la palabra. Aparece siempre que la palabra se puede oír.",
	obTipThirsty_title: "Hora de regar",
	obTipThirsty_body: "Algunas de sus plantas están sedientas. Haga clic en la etiqueta para poner en la bandeja justo esas palabras y darles un riego rápido.",
	obTipDirection_title: "Cambiar de sentido",
	obTipDirection_body: "Responda en el idioma que está aprendiendo, en el propio o mezcle ambos en una misma sesión. El botón del altavoz permite ejercitar de oído.",
	obTipMyGarden_title: "Aquí vive su jardín",
	obTipMyGarden_body: "Cada palabra plantada está en Mi jardín: creciendo, pidiendo agua o en plena floración.",
	obTipAddPill_title: "Añadir más palabras",
	obTipAddPill_body: "Añadir traslada palabras de esta lista a su bandeja. Un puñado cada vez es lo que mejor crece.",
	obTipDictLookup_title: "Consulte lo que sea",
	obTipDictLookup_body: "Escriba cualquier palabra del idioma que está aprendiendo: con significados, ejemplos y gramática incluidos.",
	obTipGear_title: "A su medida",
	obTipGear_body: "Velocidad de la sesión, repeticiones, nivel de exigencia: ajuste aquí su práctica.",

	// ── The help hub: the "?" in the tabs row (js/onboarding.js, spec §7) ──
	obHelpMenu_label: "Ayuda",
	obHelpMenuTip_label: "Consejo del día",
	obHelpMenuAllTips_label: "Todos los consejos",
	obHelpMenuReplay_label: "Recorrido guiado",
	obHelpMenuWlTour_label: "Recorrido por las listas",
	obHelpMenuWelcome_label: "Pantalla de bienvenida",
	// The hub's one setting: guided MODE (tooltip-engine-consolidation.md §4.9). Its row has
	// no label key of its own — it shows tipMakeSmall_label / tipMakeLarge_label, the same two
	// strings the tooltip's corner button uses. NOT the tour's guided RUN.

	// ── Tip of the day (js/tips.js, docs/project/tip-of-the-day.md) ──
	tipDay_title: "Consejo del día",
	tipsAll_title: "Todos los consejos",
	tipsClose_label: "Cerrar",
	// The interruption is what is switched off, not the tips — hence the toast naming where it
	// went, and hence the switch below saying what it turns back ON.
	tipsOff_toast: "Los consejos están desactivados. Vuelva a activarlos en Ayuda ▸ Todos los consejos.",
	tipsDaily_label: "Mostrar un consejo al día",
	tipsToday_label: "Hoy",
	// The tease line's speaker. No shortcut in the face, unlike sound_tooltip: Space belongs to
	// the word on the card behind this popup, and claiming it here would take it from there.
	tipTeaseSound_tooltip: "Escuchar esta frase",
	tsDefinitionWasNotSet: "No se pudo obtener la definición de la palabra",
	settings_tooltip: "Ajustes",
	prefSpeed_tooltip: "Con qué rapidez corre la cuenta atrás mientras se escribe. Las respuestas largas reciben más tiempo; 1 es tranquilo, 10 es un esprint.<p>Una palabra fallada recibe tiempo extra la próxima vez que aparezca.",
	prefAdaptiveSpeed_tooltip: "Dentro de una sesión, cada acierto en una palabra hace que su siguiente aparición sea un poco más rápida — {0}% por paso, hasta {1} pasos — y un fallo la retrasa un paso. La primera aparición de una palabra siempre va a la velocidad normal.",
	prefStrictCaps_tooltip: "Las mayúsculas cuentan: la respuesta debe coincidir exactamente con las mayúsculas de la palabra. Desactivado, mayúsculas y minúsculas se tratan igual.",
	prefDrillArticle_tooltip: "Un sustantivo solo es correcto con su artículo: <i>der Kunde</i>, no solo <i>Kunde</i>. El artículo forma parte de la palabra, así que forma parte de lo que se escribe. Desactivado, se escribe el sustantivo solo.",
	prefSelfCheck_tooltip: "Cuando aparece la palabra y se pide su significado, se responde mentalmente en vez de escribir: indique si la entiende, vea la respuesta y luego indique si acertó. Desactivado, el significado se escribe.",
	prefGapPhrases_tooltip: "Se muestra una oración sin su palabra clave, y esa palabra es lo único que se escribe. Desactivado, se escribe la oración entera.<p>Las expresiones cortas siempre se escriben completas: su redacción exacta es lo importante.",
	prefStrictness_tooltip: "Cuántas pruebas necesita una palabra para darse por superada y crecer en su jardín. Izquierda: escrita de memoria tras ver la respuesta, o casi acertada, y las sesiones se mantienen cortas. Derecha: escrita con exactitud antes de que acabe la cuenta atrás, más de una vez.<p>La línea bajo el deslizador explica la posición elegida.",
	prefVerbOnlyIrregular_tooltip: "La lista de Conjugación conserva solo los verbos irregulares: aquellos cuyas formas hay que aprender una a una. Desactivado, incluye todos los verbos, también los regulares.",
	prefVerbFullParadigm_tooltip: "Un verbo añadido desde la lista de Conjugación trae su tabla completa: seis tiempos en seis personas, 36 formas. Desactivado, trae ocho formas clave: presente <i>ich, du, er, wir</i>; perfecto <i>ich, er</i>; pasado <i>ich, du</i>.",
	prefVerbPronounPrefill_tooltip: "En una tarjeta de conjugación el pronombre ya aparece delante del campo de respuesta y solo se escribe la forma verbal: <i>ich</i> viene dado, <i>fahre</i> se escribe. Desactivado, también se escribe el pronombre.",
	prefTypedRowOff_tooltip: "No se aplica en esta dirección: aquí se responde con el significado, no con la palabra que está aprendiendo.",
	prefSelfCheckOff_tooltip: "No se aplica en esta dirección: aquí se escribe la palabra que está aprendiendo, así que no hay nada que autocomprobar.",
	ai_unknownWord_error: '"{0}" no es una palabra conocida en {1}.',
	ai_disabled_error: "La búsqueda con IA no está disponible por ahora.",
	ai_signIn_error: "Inicie sesión para buscar palabras nuevas hoy.",
	audio_signIn_message: "Inicie sesión para seguir escuchando palabras nuevas.",
	phraseTooLong_message: "Eso es un poco largo para nuestro diccionario: el límite es de 8 palabras y 80 caracteres en total.",
	rich_loading_message: "Buscando…",
	rich_failed_message: "La búsqueda falló. Inténtelo de nuevo.",
	rich_enriching_message: "Estamos preparando la entrada completa…",
	rich_enrichFailed_message: "De esta palabra, por ahora solo está la traducción.",
	// La banda de colocaciones bajo las filas A–Z (solo en dirección directa).
	phraseBand_words_label: "En palabras",
	phraseBand_collocations_label: "En colocaciones",
	phraseBand_examples_label: "En ejemplos",
	phraseBand_myPhrases_label: "De expresiones que escribí",
	phraseBand_noEntry_message: "No hay entrada del diccionario para «{0}»",
	phraseBand_stripOpen_tooltip: "Ver lo encontrado",
	phraseBand_stripClose_tooltip: "Ocultar estos resultados",
	phraseBand_pagerFirst_tooltip: "Volver a la primera fila",
	phraseBand_pagerPrev_tooltip: "Retroceder {0} filas — mantenga pulsado para seguir",
	phraseBand_pagerNext_tooltip: "Avanzar {0} filas — mantenga pulsado para seguir",
	phraseBand_pagerLast_tooltip: "A las últimas filas",
	phraseBand_pagerRow_tooltip: "Filas {0}–{1} de {2} — haga clic para saltar",
	// The wrong-toggle nudge: shown INSTEAD of generating an entry, when the typed word is not a
	// word of the language being learned but is a known meaning in the learner's own language.
	dict_wrongDirection_message: "«{0}» parece una palabra en {1}.",
	dict_wrongDirection_switch: "Buscar {0} → {1}",
	dict_wrongDirection_anyway: "No — buscarla en {0}",
	dict_openMatch_prefix_message: "¿Quiso decir «{0}»?",
	dict_openMatch_corrected_message: "Mostrando «{0}».",
	dict_openMatch_lookup_link: "Buscar «{0}» en su lugar",
	reverse_phrases_shown: "Mostrando las primeras {0} de {1}",
	stats_panel_title: "Mi progreso",
	stats_scope_tooltip: "Todo lo que ha estudiado en {0}. Cuenta cada sesión, sea cual sea el idioma en que se escribieron sus pistas.",
	stats_label_mastered: "palabras dominadas",
	stats_label_accuracy: "precisión",
	stats_label_sessions: "sesiones",
	stats_label_studied: "estudiadas",
	stats_streak: "racha de {0} días",
	stats_best_streak: "mejor: {0}",
	stats_today: "Hoy: {0} palabras · {1}",
	stats_coverage: "{0} de las {1} palabras más frecuentes",
	stats_seen: "{0} palabras vistas",
	stats_learning: "{0} en curso",
	exSummary_flawless: "impecable",
	exSummary_time: "tiempo de sesión",
	exSummary_speed: "respuesta típica",
	exSummary_tricky: "Palabras difíciles de esta sesión: ¿desea añadirlas a la lista Palabras difíciles?",
	exSummary_offerDifficult_tooltip: "Añadir a Palabras difíciles en Mi jardín",
	exSummary_difficultGraduated: "¡Ya no son difíciles! 🎉",
	exSummary_difficultProgress: "¡Buen avance con las palabras difíciles!",
	exSummary_difficultFiled: "Añadidas a Palabras difíciles:",
	exSummary_difficultFiled_shown: "— la respuesta se mostró {0} veces",
	exSummary_difficultFiled_shownFew: "— la respuesta se mostró {0} veces",
	phrasePick_tooltip: "Ejercitar en expresiones: elija frases reales con esta palabra",
	phrasePickTitle_label: "“{0}” en expresiones",
	phrasePickAdd_label: "Añadir al ejercicio",
	phrasePickDrop_tooltip: "Dejar esta fuera",
	phrasePickRestore_tooltip: "Volver a incluirla",
	phrasePickNone_message: "No quedan expresiones para añadir a “{0}”: o todavía no hay ninguna guardada, o ya las tiene todas.",
	phrasePickAdded_message: "Añadidas a su ejercicio.",
	exSummary_bridgeMastered: "{0} palabras dominadas en total",
	exOutcome_recalledCold: "recordada en frío",
	exOutcome_knownSlow: "sabida — recuerdo lento",
	exOutcome_knownArticle: "sabida — artículo dudoso, la palabra en sí está ahí",
	exOutcome_warmUp: "necesitó calentamiento",
	exOutcome_relearned: "hubo que mostrar la respuesta — volverá antes",
	exOutcome_earlyPractice: "regada un poco — crecerá del todo cuando toque",
	exOutcome_practiced: "practicada — crecerá cuando toque",
	exSummary_grewToday: "Crecieron hoy ({0})",
	exSummary_stillGrowing: "Siguen creciendo ({0})",
	exOutcome_recalledCold_tooltip: "Primera vez que se mostró: respuesta correcta, al instante y sin ayuda.",
	exOutcome_knownSlow_tooltip: "La palabra volvió, solo que más despacio de lo habitual en ella. Cuenta como sabida.",
	exOutcome_knownArticle_tooltip: "El sustantivo volvió; el artículo no. Se preguntó de nuevo, pero la palabra en sí cuenta como recordada.",
	exOutcome_warmUp_tooltip: "No salió limpia al primer intento: un desliz pequeño o una respuesta que llegó después del momento que cuenta como recuerdo instantáneo. Aun así cuenta como recuerdo, no como fallo.",
	exOutcome_relearned_tooltip: "Hubo que mostrar la respuesta para que esta palabra volviera. Se programa antes de lo que le habría tocado.",
	exOutcome_earlyPractice_tooltip: "Ha practicado esta palabra antes de su día de riego. Cuenta, pero la planta da su paso en la fecha que muestra la insignia: practicar antes no lo adelanta.",
	exOutcome_earlyPractice_tooltip_v2: "Ha practicado esta palabra antes de su día de riego. Cuenta, pero la próxima marca de crecimiento de la planta es un día fijo de su propio calendario, no la fecha que muestra la insignia: solo un acierto en esa marca, o justo antes, la consigue.",
	exOutcome_practiced_tooltip: "Ya había practicado esta palabra hoy. Una segunda vuelta el mismo día no cuenta como repetición nueva: el siguiente paso llega con el próximo riego.",
	exSummary_grewToday_tooltip: "Estas palabras subieron una etapa hoy; la flecha muestra el paso. Una planta crece cuando la estimación de cuánto tiempo seguiría recordando la palabra supera la siguiente marca: 1, 3, 7, 14, 30, 60 o 90 días.",
	exSummary_stillGrowing_tooltip: "Estas palabras se regaron, pero mantuvieron su etapa, que es lo habitual. El número delante de cada palabra es el próximo riego, y suele alejarse aunque la imagen no cambie. La planta solo cambia cuando la estimación supera la siguiente marca: 1, 3, 7, 14, 30, 60 o 90 días.",
	// The heading those two share for the moment before the server has scored the session — see
	// renderWordSections. It names the only thing known then: which words were drilled.
	exSummary_sessionWords: "Palabras de esta sesión ({0})",
	exSummary_sessionWords_tooltip: "Todas las palabras ejercitadas en esta sesión. Lo que creció y lo que mantuvo su etapa aparece un momento después, en cuanto se puntúa la sesión.",
	garden_grow_title: "Crecimiento de hoy",
	// The same bed when nothing grew — it still holds every word the session drilled, so it is
	// named for what it honestly is rather than claiming growth that did not happen.
	garden_bed_session: "Palabras de esta sesión",
	garden_not_planted: "Sin plantar aún",
	garden_grow_next: "próximo riego en {0}",
	conj_tense_present: "Presente",
	conj_tense_past: "Pasado (pretérito)",
	conj_tense_perfect: "Perfecto",
	conj_tense_past_perfect: "Pluscuamperfecto",
	conj_tense_future: "Futuro",
	conj_tense_conditional: "Condicional (-ría)",
	// German textbook term + the SAME Spanish name the chip above already carries — no new
	// translation, just the pairing (nothing here is a
	// word this bundle didn't already use).
	conj_tense_present_tip: "Präsens / presente",
	conj_tense_past_tip: "Präteritum / pasado simple",
	conj_tense_perfect_tip: "Perfekt / pretérito perfecto",
	conj_tense_past_perfect_tip: "Plusquamperfekt / pluscuamperfecto",
	conj_tense_future_tip: "Futur / futuro",
	conj_tense_conditional_tip: "Konjunktiv II / condicional (-ría)",
	// ── The Spanish conjugation panel (F2a, 2026-09-08) ──────────────────────────────────
	// The nine stored TAMs of register §2.5 plus the RENDERED negative imperative, which is
	// no + the present subjunctive and is never stored. The panel heads its columns with the
	// SPANISH name (Util.paradigmPack.ES in main.js), exactly as the German table heads its
	// own with Präsens; these are the learner-language names — the chip on a card, and the
	// header's hover tip.
	conj_tense_es_pres_ind: "Presente",
	conj_tense_es_pret_ind: "Pretérito indefinido",
	conj_tense_es_imp_aff: "Imperativo",
	conj_tense_es_imp_neg: "Imperativo negativo",
	conj_tense_es_imperf_ind: "Pretérito imperfecto",
	conj_tense_es_fut_ind: "Futuro",
	conj_tense_es_cond: "Condicional",
	conj_tense_es_pres_subj: "Presente de subjuntivo",
	conj_tense_es_imperf_subj_ra: "Imperfecto de subjuntivo (-ra)",
	conj_tense_es_imperf_subj_se: "Imperfecto de subjuntivo (-se)",
	conj_tense_es_pres_ind_tip: "presente / tiempo presente",
	conj_tense_es_pret_ind_tip: "pretérito indefinido / pasado terminado",
	conj_tense_es_imp_aff_tip: "imperativo / órdenes",
	conj_tense_es_imp_neg_tip: "imperativo negativo / no + presente de subjuntivo",
	conj_tense_es_imperf_ind_tip: "pretérito imperfecto / pasado durativo o habitual",
	conj_tense_es_fut_ind_tip: "futuro simple / tiempo futuro",
	conj_tense_es_cond_tip: "condicional / condicional simple",
	conj_tense_es_pres_subj_tip: "presente de subjuntivo / subjuntivo presente",
	conj_tense_es_imperf_subj_ra_tip: "imperfecto de subjuntivo / subjuntivo pasado, forma habitual",
	conj_tense_es_imperf_subj_se_tip: "imperfecto de subjuntivo / variante en -se",
	// ── The Spanish FORM KINDS (F2b, 2026-09-08) ─────────────────────────────────────────
	// 77 kinds — 49 simple finite cells, 6 affirmative imperatives, 4 non-finite, 4 nominal,
	// 6 adjectival, 1 derived, 7 determiner/numeral — reached through PosLabel.CANON, exactly
	// like the German block above. ⭐ The _label is the SAME compact code in every bundle: a
	// finite cell names a tense AND a person, which no language abbreviates in five characters,
	// so the chip is Spanish-derived (pr2pl, ra3sg, ip1pl) and the _tooltip is the learner's.
	// Written by analytics/i18n/add_es_form_kind_keys.py — the tense halves are asserted equal
	// to the panel's own conj_tense_es_* values, so one screen never names a tense two ways.
	posVerbPresInd1Sg_label: "pr1sg",
	posVerbPresInd1Sg_tooltip: "Presente, 1.ª persona del singular (yo)",
	posVerbPresInd2SgTu_label: "pr2sg",
	posVerbPresInd2SgTu_tooltip: "Presente, 2.ª persona del singular (tú)",
	posVerbPresInd2SgVos_label: "prvos",
	posVerbPresInd2SgVos_tooltip: "Presente, 2.ª persona del singular, voseo (vos)",
	posVerbPresInd3Sg_label: "pr3sg",
	posVerbPresInd3Sg_tooltip: "Presente, 3.ª persona del singular (él, ella, usted)",
	posVerbPresInd1Pl_label: "pr1pl",
	posVerbPresInd1Pl_tooltip: "Presente, 1.ª persona del plural (nosotros)",
	posVerbPresInd2PlVosotros_label: "pr2pl",
	posVerbPresInd2PlVosotros_tooltip: "Presente, 2.ª persona del plural, España (vosotros)",
	posVerbPresInd3Pl_label: "pr3pl",
	posVerbPresInd3Pl_tooltip: "Presente, 3.ª persona del plural (ellos, ellas, ustedes)",
	posVerbPretInd1Sg_label: "pt1sg",
	posVerbPretInd1Sg_tooltip: "Pretérito indefinido, 1.ª persona del singular (yo)",
	posVerbPretInd2SgTu_label: "pt2sg",
	posVerbPretInd2SgTu_tooltip: "Pretérito indefinido, 2.ª persona del singular (tú)",
	posVerbPretInd3Sg_label: "pt3sg",
	posVerbPretInd3Sg_tooltip: "Pretérito indefinido, 3.ª persona del singular (él, ella, usted)",
	posVerbPretInd1Pl_label: "pt1pl",
	posVerbPretInd1Pl_tooltip: "Pretérito indefinido, 1.ª persona del plural (nosotros)",
	posVerbPretInd2PlVosotros_label: "pt2pl",
	posVerbPretInd2PlVosotros_tooltip: "Pretérito indefinido, 2.ª persona del plural, España (vosotros)",
	posVerbPretInd3Pl_label: "pt3pl",
	posVerbPretInd3Pl_tooltip: "Pretérito indefinido, 3.ª persona del plural (ellos, ellas, ustedes)",
	posVerbImperfInd1Sg_label: "im1sg",
	posVerbImperfInd1Sg_tooltip: "Pretérito imperfecto, 1.ª persona del singular (yo)",
	posVerbImperfInd2SgTu_label: "im2sg",
	posVerbImperfInd2SgTu_tooltip: "Pretérito imperfecto, 2.ª persona del singular (tú)",
	posVerbImperfInd3Sg_label: "im3sg",
	posVerbImperfInd3Sg_tooltip: "Pretérito imperfecto, 3.ª persona del singular (él, ella, usted)",
	posVerbImperfInd1Pl_label: "im1pl",
	posVerbImperfInd1Pl_tooltip: "Pretérito imperfecto, 1.ª persona del plural (nosotros)",
	posVerbImperfInd2PlVosotros_label: "im2pl",
	posVerbImperfInd2PlVosotros_tooltip: "Pretérito imperfecto, 2.ª persona del plural, España (vosotros)",
	posVerbImperfInd3Pl_label: "im3pl",
	posVerbImperfInd3Pl_tooltip: "Pretérito imperfecto, 3.ª persona del plural (ellos, ellas, ustedes)",
	posVerbFutInd1Sg_label: "fu1sg",
	posVerbFutInd1Sg_tooltip: "Futuro, 1.ª persona del singular (yo)",
	posVerbFutInd2SgTu_label: "fu2sg",
	posVerbFutInd2SgTu_tooltip: "Futuro, 2.ª persona del singular (tú)",
	posVerbFutInd3Sg_label: "fu3sg",
	posVerbFutInd3Sg_tooltip: "Futuro, 3.ª persona del singular (él, ella, usted)",
	posVerbFutInd1Pl_label: "fu1pl",
	posVerbFutInd1Pl_tooltip: "Futuro, 1.ª persona del plural (nosotros)",
	posVerbFutInd2PlVosotros_label: "fu2pl",
	posVerbFutInd2PlVosotros_tooltip: "Futuro, 2.ª persona del plural, España (vosotros)",
	posVerbFutInd3Pl_label: "fu3pl",
	posVerbFutInd3Pl_tooltip: "Futuro, 3.ª persona del plural (ellos, ellas, ustedes)",
	posVerbCond1Sg_label: "co1sg",
	posVerbCond1Sg_tooltip: "Condicional, 1.ª persona del singular (yo)",
	posVerbCond2SgTu_label: "co2sg",
	posVerbCond2SgTu_tooltip: "Condicional, 2.ª persona del singular (tú)",
	posVerbCond3Sg_label: "co3sg",
	posVerbCond3Sg_tooltip: "Condicional, 3.ª persona del singular (él, ella, usted)",
	posVerbCond1Pl_label: "co1pl",
	posVerbCond1Pl_tooltip: "Condicional, 1.ª persona del plural (nosotros)",
	posVerbCond2PlVosotros_label: "co2pl",
	posVerbCond2PlVosotros_tooltip: "Condicional, 2.ª persona del plural, España (vosotros)",
	posVerbCond3Pl_label: "co3pl",
	posVerbCond3Pl_tooltip: "Condicional, 3.ª persona del plural (ellos, ellas, ustedes)",
	posVerbPresSubj1Sg_label: "sb1sg",
	posVerbPresSubj1Sg_tooltip: "Presente de subjuntivo, 1.ª persona del singular (yo)",
	posVerbPresSubj2SgTu_label: "sb2sg",
	posVerbPresSubj2SgTu_tooltip: "Presente de subjuntivo, 2.ª persona del singular (tú)",
	posVerbPresSubj3Sg_label: "sb3sg",
	posVerbPresSubj3Sg_tooltip: "Presente de subjuntivo, 3.ª persona del singular (él, ella, usted)",
	posVerbPresSubj1Pl_label: "sb1pl",
	posVerbPresSubj1Pl_tooltip: "Presente de subjuntivo, 1.ª persona del plural (nosotros)",
	posVerbPresSubj2PlVosotros_label: "sb2pl",
	posVerbPresSubj2PlVosotros_tooltip: "Presente de subjuntivo, 2.ª persona del plural, España (vosotros)",
	posVerbPresSubj3Pl_label: "sb3pl",
	posVerbPresSubj3Pl_tooltip: "Presente de subjuntivo, 3.ª persona del plural (ellos, ellas, ustedes)",
	posVerbImperfSubjRa1Sg_label: "ra1sg",
	posVerbImperfSubjRa1Sg_tooltip: "Imperfecto de subjuntivo (-ra), 1.ª persona del singular (yo)",
	posVerbImperfSubjRa2SgTu_label: "ra2sg",
	posVerbImperfSubjRa2SgTu_tooltip: "Imperfecto de subjuntivo (-ra), 2.ª persona del singular (tú)",
	posVerbImperfSubjRa3Sg_label: "ra3sg",
	posVerbImperfSubjRa3Sg_tooltip: "Imperfecto de subjuntivo (-ra), 3.ª persona del singular (él, ella, usted)",
	posVerbImperfSubjRa1Pl_label: "ra1pl",
	posVerbImperfSubjRa1Pl_tooltip: "Imperfecto de subjuntivo (-ra), 1.ª persona del plural (nosotros)",
	posVerbImperfSubjRa2PlVosotros_label: "ra2pl",
	posVerbImperfSubjRa2PlVosotros_tooltip: "Imperfecto de subjuntivo (-ra), 2.ª persona del plural, España (vosotros)",
	posVerbImperfSubjRa3Pl_label: "ra3pl",
	posVerbImperfSubjRa3Pl_tooltip: "Imperfecto de subjuntivo (-ra), 3.ª persona del plural (ellos, ellas, ustedes)",
	posVerbImperfSubjSe1Sg_label: "se1sg",
	posVerbImperfSubjSe1Sg_tooltip: "Imperfecto de subjuntivo (-se), 1.ª persona del singular (yo)",
	posVerbImperfSubjSe2SgTu_label: "se2sg",
	posVerbImperfSubjSe2SgTu_tooltip: "Imperfecto de subjuntivo (-se), 2.ª persona del singular (tú)",
	posVerbImperfSubjSe3Sg_label: "se3sg",
	posVerbImperfSubjSe3Sg_tooltip: "Imperfecto de subjuntivo (-se), 3.ª persona del singular (él, ella, usted)",
	posVerbImperfSubjSe1Pl_label: "se1pl",
	posVerbImperfSubjSe1Pl_tooltip: "Imperfecto de subjuntivo (-se), 1.ª persona del plural (nosotros)",
	posVerbImperfSubjSe2PlVosotros_label: "se2pl",
	posVerbImperfSubjSe2PlVosotros_tooltip: "Imperfecto de subjuntivo (-se), 2.ª persona del plural, España (vosotros)",
	posVerbImperfSubjSe3Pl_label: "se3pl",
	posVerbImperfSubjSe3Pl_tooltip: "Imperfecto de subjuntivo (-se), 3.ª persona del plural (ellos, ellas, ustedes)",
	posImpAff2SgTu_label: "ip2sg",
	posImpAff2SgTu_tooltip: "Imperativo, 2.ª persona del singular (tú)",
	posImpAff2SgVos_label: "ipvos",
	posImpAff2SgVos_tooltip: "Imperativo, 2.ª persona del singular, voseo (vos)",
	posImpAff3SgUsted_label: "ip3sg",
	posImpAff3SgUsted_tooltip: "Imperativo, 3.ª persona del singular (usted)",
	posImpAff1Pl_label: "ip1pl",
	posImpAff1Pl_tooltip: "Imperativo, 1.ª persona del plural (nosotros)",
	posImpAff2PlVosotros_label: "ip2pl",
	posImpAff2PlVosotros_tooltip: "Imperativo, 2.ª persona del plural, España (vosotros)",
	posImpAff3PlUstedes_label: "ip3pl",
	posImpAff3PlUstedes_tooltip: "Imperativo, 3.ª persona del plural (ustedes)",
	posInfinitive_label: "inf",
	posInfinitive_tooltip: "infinitivo",
	posGerund_label: "ger",
	posGerund_tooltip: "gerundio (-ando / -iendo)",
	posParticiple_label: "part",
	posParticiple_tooltip: "participio",
	posParticipleAlt_label: "part2",
	posParticipleAlt_tooltip: "participio, segunda forma",
	posNounPlural_label: "pl",
	posNounPlural_tooltip: "plural",
	posNounFeminineSg_label: "fsg",
	posNounFeminineSg_tooltip: "femenino singular, sustantivo",
	posNounFemininePl_label: "fpl",
	posNounFemininePl_tooltip: "femenino plural, sustantivo",
	posNounMascPlOfFemHead_label: "mpl",
	posNounMascPlOfFemHead_tooltip: "masculino plural de una entrada femenina",
	posAdjFemSg_label: "fsg",
	posAdjFemSg_tooltip: "femenino singular, adjetivo",
	posAdjMascPl_label: "mpl",
	posAdjMascPl_tooltip: "masculino plural, adjetivo",
	posAdjFemPl_label: "fpl",
	posAdjFemPl_tooltip: "femenino plural, adjetivo",
	posAdjApocope_label: "apoc",
	posAdjApocope_tooltip: "apócope ante sustantivo (gran, buen)",
	posAdjSuperlativoAbsoluto_label: "sup",
	posAdjSuperlativoAbsoluto_tooltip: "superlativo absoluto (-ísimo)",
	posAdjSuperlativoAbsolutoAlt_label: "sup2",
	posAdjSuperlativoAbsolutoAlt_tooltip: "superlativo absoluto, segunda forma",
	posAdvMente_label: "adv",
	posAdvMente_tooltip: "adverbio en -mente",
	posDetFemSg_label: "fsg",
	posDetFemSg_tooltip: "femenino singular, determinante",
	posDetMascPl_label: "mpl",
	posDetMascPl_tooltip: "masculino plural, determinante",
	posDetFemPl_label: "fpl",
	posDetFemPl_tooltip: "femenino plural, determinante",
	posDetNeuter_label: "neut",
	posDetNeuter_tooltip: "forma neutra (lo, esto)",
	posDetApocope_label: "apoc",
	posDetApocope_tooltip: "apócope ante sustantivo",
	posNumFeminine_label: "fem",
	posNumFeminine_tooltip: "numeral femenino (una, doscientas)",
	posNumApocope_label: "napo",
	posNumApocope_tooltip: "numeral apocopado (un, cien)",
	conj_person_firstSg: "1.ª pers. sing.",
	conj_person_secondSg: "2.ª pers. sing.",
	conj_person_thirdSg: "3.ª pers. sing.",
	conj_person_firstPl: "1.ª pers. pl.",
	conj_person_secondPl: "2.ª pers. pl.",
	conj_person_thirdPl: "3.ª pers. pl.",
	rich_perfect_tooltip: "Perfecto: cómo forma este verbo el perfecto, «hat …» con haben, «ist …» con sein",

	// ── Regla F7: la clase de irregularidad española (F2b, plan §4b fila 8) ────────────────────
	// Por clase, un `_label` (la alternancia, en forma de chip) y un `_note` (la línea que la
	// explica). El verbo de ejemplo es español en todos los idiomas: es la lengua que se aprende.
	verb_class_tooltip: 'Clase de irregularidad: cómo se mueve la raíz de este verbo. Las casillas de presente resaltadas son las que cambian; las demás siguen el modelo regular.',
	verbClassOrtografico_label: 'solo ortografía',
	verbClassOrtografico_note: 'La escritura cambia para que el sonido no cambie: coger → cojo.',
	verbClassEIe_label: 'e → ie',
	verbClassEIe_note: 'La vocal de la raíz diptonga cuando lleva el acento: tener → tiene.',
	verbClassOUe_label: 'o → ue',
	verbClassOUe_note: 'La vocal de la raíz diptonga cuando lleva el acento: llover → llueve.',
	verbClassEI_label: 'e → i',
	verbClassEI_note: 'La vocal de la raíz se cierra cuando lleva el acento: pedir → pide.',
	verbClassEIeI_label: 'e → ie / i',
	verbClassEIeI_note: 'Diptongo con acento, vocal cerrada sin él: sentir → siente, sintió.',
	verbClassOUeU_label: 'o → ue / u',
	verbClassOUeU_note: 'Diptongo con acento, vocal cerrada sin él: dormir → duerme, durmió.',
	verbClassZco_label: '-zco',
	verbClassZco_note: 'La primera persona del singular termina en -zco, y todo el subjuntivo la sigue: conocer → conozco.',
	verbClassIAcento_label: 'i → í',
	verbClassIAcento_note: 'La vocal débil lleva tilde cuando se acentúa y mantiene su propia sílaba: ampliar → amplío.',
	verbClassUAcento_label: 'u → ú',
	verbClassUAcento_note: 'La vocal débil lleva tilde cuando se acentúa y mantiene su propia sílaba: actuar → actúo.',
	verbClassEAcento_label: 'e → í',
	verbClassEAcento_note: 'La e de la raíz se escribe í cuando lleva el acento: reír → río.',
	verbClassIIe_label: 'i → ie',
	verbClassIIe_note: 'La vocal de la raíz diptonga cuando lleva el acento: adquirir → adquiere.',
	verbClassEYe_label: 'e → ye',
	verbClassEYe_note: 'A principio de palabra el diptongo se escribe ye: errar → yerro.',
	verbClassUUe_label: 'u → ue',
	verbClassUUe_note: 'La vocal de la raíz diptonga cuando lleva el acento: jugar → juega.',
	verbClassOHue_label: 'o → hue',
	verbClassOHue_note: 'A principio de palabra el diptongo se escribe hue: oler → huele.',
	// ── SPANISH SENSE FIELDS (S4, 2026-09-08) ───────────────────────────────────────────
	// The copula and position splits, the sense's variety limits, and the shape of a
	// government frame. Region labels are looked up FROM THE CODE — never a prose prefix in
	// a gloss (register clause 14) and never a preposition in a template (a region reads as
	// `label: A, B`, because `en Espagne` / `au Mexique` cannot both come out of one hole).
	senseCopulaSer_label: 'con ser',
	senseCopulaEstar_label: 'con estar',
	senseCopulaAmbos_label: 'ser o estar',
	sensePositionPrenominal_label: 'antepuesto',
	sensePositionPostnominal_label: 'pospuesto',
	sensePositionEither_label: 'ambas posiciones',
	senseRegionTypeOnlyIn_label: 'solo',
	senseRegionTypeNotIn_label: 'no se usa',
	senseRegionTypePreferredIn_label: 'preferido',
	senseRegionES_label: 'España',
	senseRegionMX_label: 'México',
	senseRegionAR_label: 'Argentina',
	senseRegionUY_label: 'Uruguay',
	senseRegionPY_label: 'Paraguay',
	senseRegionCL_label: 'Chile',
	senseRegionPE_label: 'Perú',
	senseRegionBO_label: 'Bolivia',
	senseRegionEC_label: 'Ecuador',
	senseRegionCO_label: 'Colombia',
	senseRegionVE_label: 'Venezuela',
	senseRegionCR_label: 'Costa Rica',
	senseRegionGT_label: 'Guatemala',
	senseRegionHN_label: 'Honduras',
	senseRegionNI_label: 'Nicaragua',
	senseRegionPA_label: 'Panamá',
	senseRegionSV_label: 'El Salvador',
	senseRegionCU_label: 'Cuba',
	senseRegionDO_label: 'República Dominicana',
	senseRegionPR_label: 'Puerto Rico',
	senseRegionGQ_label: 'Guinea Ecuatorial',
	senseRegionUS_label: 'Estados Unidos',
	senseRegionAM_label: 'América',
	senseRegionRPL_label: 'Río de la Plata',
	senseRegionCAM_label: 'Centroamérica',
	senseRegionAND_label: 'Zona andina',
	senseRegionCAR_label: 'Caribe',
	senseRegionCAN_label: 'Canarias',
	senseConstructionPrepNp_label: '+ sustantivo',
	senseConstructionPrepInf_label: '+ infinitivo',
	senseConstructionPrepQueInd_label: '+ que + indicativo',
	senseConstructionPrepQueSubj_label: '+ que + subjuntivo',
	senseConstructionQueInd_label: 'que + indicativo',
	senseConstructionQueSubj_label: 'que + subjuntivo',
	senseConstructionInfDirecto_label: '+ infinitivo directo',
	senseConstructionDativoExperimentante_label: 'experimentador en dativo · me gusta el café',
	senseConstructionObjetoDativo_label: '+ le (objeto dativo)',
	senseConstructionObjetoAcusativo_label: '+ objeto directo',
	senseConstructionSeImpersonal_label: 'se impersonal',
	senseMoodInd_label: '+ indicativo',
	senseMoodSubj_label: '+ subjuntivo',

	// ── Historial de sesiones (js/session_history.js) ──
	hist_title: "Historial de sesiones",
	hist_tooltip: "Todas las sesiones de práctica terminadas con este par",
	hist_back_label: "Atrás",
	hist_loading: "Cargando…",
	hist_failed: "No se pudo cargar el historial de sesiones.",
	hist_empty: "Aún no hay sesiones de práctica terminadas con este par.",
	hist_today: "Hoy",
	hist_yesterday: "Ayer",
	hist_col_time: "Hora",
	hist_col_mastered: "Dominadas",
	hist_col_flawless: "Perfectas",
	hist_col_accuracy: "Precisión",
	hist_col_shown: "Mostradas",
	hist_col_wrong: "Fallos",
	hist_col_spent: "Tiempo",
	hist_col_typical: "Habitual",
	hist_of: "de {0}",
	hist_of_label: "de",
	hist_stopped: "detenida antes de tiempo",
	hist_dir_mix: "Mixta",
	hist_dir_byEar: "De oído",
	hist_origin_random: "Palabras al azar",
	hist_origin_search: "Palabras buscadas",
	hist_origin_list: "Lista: {0}",
	hist_fact_when: "Cuándo",
	hist_fact_direction: "Dirección",
	hist_fact_source: "Origen de las palabras",
	hist_fact_set: "Palabras del conjunto",
	hist_fact_shown: "Veces mostradas",
	hist_fact_correct: "Aciertos",
	hist_fact_wrong: "Respuesta revelada",
	hist_fact_replays: "Repeticiones de sonido",
	hist_fact_outcome: "Final",
	hist_outcome_completed: "Completada",
	hist_outcome_stopped: "Detenida antes de tiempo",
	hist_flawless_legend: "acertada siempre — nunca revelada, ningún intento fallido",
	hist_tip_time: "Cuándo comenzó esta sesión de práctica.",
	hist_tip_mastered: "Palabras terminadas: retiradas por hoy, de entre las que la sesión se propuso ejercitar.",
	hist_tip_flawless: "Palabras acertadas en todas sus apariciones: nunca reveladas y sin ninguna respuesta incorrecta por el camino.",
	hist_tip_accuracy: "Aciertos ÷ apariciones. Una aparición termina con una respuesta correcta o con la respuesta revelada, así que esta es la proporción resuelta por cuenta propia.",
	hist_tip_shown: "Cuántas veces se presentaron palabras para responder, contando las repeticiones.",
	hist_tip_right: "Cuántas de esas apariciones se respondieron correctamente, sin importar cuántos intentos hicieran falta dentro del tiempo límite.",
	hist_tip_wrong: "Cuántas apariciones terminaron con la respuesta revelada: se acabó el tiempo o se pidió verla.",
	hist_tip_spent: "De la primera palabra a la última: la sesión entera, pausas incluidas.",
	hist_tip_typical: "Lo que solía tardar un acierto: el valor intermedio entre todas las palabras, para que una expresión larga no lo distorsione.",
	hist_tip_direction: "En qué sentido se preguntó: primero el idioma de la pregunta, después el de la respuesta.",
	hist_tip_when: "El día y la hora en que se desarrolló esta sesión, de principio a fin.",
	hist_tip_source: "De dónde salieron las palabras.",
	hist_tip_set: "Cuántas palabras se pusieron en la bandeja para esta sesión.",
	hist_tip_replays: "Cuántas veces se volvió a reproducir el sonido de una palabra antes de responder. Es una ayuda solicitada, no un error.",
	hist_tip_outcome: "Si la sesión llegó al final o se interrumpió antes.",
	hist_tip_word: "La palabra a la que se refiere esta fila. Haga clic en la fila para ver todo su historial de aprendizaje.",
	hist_tip_meaning: "Con qué significado se ejercitó la palabra en esta sesión: los significados que pidieron sus tarjetas.",
	hist_tip_wshown: "Cuántas veces se presentó esta palabra para responder.",
	hist_tip_wright: "Cuántas de esas apariciones se respondieron correctamente, sin importar cuántos intentos hicieran falta dentro del tiempo límite.",
	hist_tip_wwrong: "Cuántas apariciones terminaron con la respuesta revelada: se acabó el tiempo o se pidió verla.",
	hist_tip_wtypical: "Su tiempo medio hasta un acierto en esta palabra. Las apariciones que quedaron sin responder no cuentan.",
	hist_tip_firstTry: "Acierto en la primerísima aparición, sin ninguna respuesta incorrecta en ella: una palabra que ya se sabía. Lo que ocurriera en las repeticiones no le afecta.",
	hist_tip_wflawless: "Acierto en todas las apariciones, sin revelar nunca la respuesta y sin ninguna respuesta incorrecta. Más estricto que un primer intento limpio.",
	hist_firstTry_legend: "acertada en la primera aparición — sin ningún intento fallido",
	hist_words_none: "No se registraron palabras en esta sesión.",
	hist_words_masteredHead: "Dominadas ({0})",
	hist_words_alsoHead: "También ejercitadas ({0})",
	hist_words_noMatch: "Ninguna palabra coincide con ese filtro.",
	hist_wcol_word: "Palabra",
	hist_wcol_meaning: "Significado",
	hist_wcol_firstTry: "1.er intento",
	hist_wcol_replays: "Escuchas",
	hist_wcol_right: "Aciertos",
	hist_wcol_growth: "Crecimiento",
	hist_wcol_next: "Próxima",
	hist_wcol_verdict: "Veredicto",
	hist_tip_growth: "Su planta para esta palabra antes y después de la sesión. Una flecha significa que creció una etapa; una sola planta atenuada significa que se mantuvo en la etapa en la que estaba, que es lo normal cuando se practica una palabra antes de que le toque.",
	hist_tip_grew: "Esta sesión hizo crecer la planta una etapa.",
	hist_tip_next: "A cuántos días quedó programada esta palabra tras la sesión: el intervalo que la aplicación estaba dispuesta a esperar antes de volver a preguntarla. Cuanto más largo, mejor se sostiene el recuerdo.",
	hist_tip_next_drawn: "Esta sesión fijó una nueva fecha para la palabra: {0}.",
	hist_tip_next_held: "Esta sesión no cambió la fecha: una práctica anticipada o una repetición el mismo día no alteran el compromiso vigente. Le sigue tocando: {0}.",
	hist_tip_verdict: "Lo que el modelo de memoria concluyó sobre esta palabra aquí, en sus propios términos. Puede no coincidir con la sensación del ejercicio: una palabra que costó sacar puede contar igualmente como recuperada, y una que salió bien puede quedar registrada como lenta.",
	hist_days_short: "{0} d",
	hist_v_cold: "recordada en frío",
	hist_v_slow: "sabida, lenta",
	hist_v_article: "sabida, artículo",
	hist_v_warmUp: "calentamiento",
	hist_v_relearned: "reaprendida",
	hist_v_early: "anticipada",
	hist_v_sameDay: "mismo día",
	hist_vtip_cold: "La palabra salió de inmediato, al primer intento, sin ayuda, y a la aplicación no le pareció lenta. La forma más limpia de recordar, y la que hace avanzar la planta a su siguiente etapa.",
	hist_vtip_slow: "Llegó por su cuenta, sin ayuda, pero por encima del tiempo que la aplicación concede para esta palabra: un margen calculado a partir de su velocidad al escribir, no un reloj fijo. Cuenta como saberla, incluso con una errata leve: el recuerdo está ahí, solo que aún no es rápido.",
	hist_vtip_article: "La palabra en sí volvió; el artículo (der / die / das), no. Cuenta como saber la palabra: lo que queda por aprender es el género, y la aplicación seguirá pidiendo ambos.",
	hist_vtip_warmUp: "La palabra volvió, pero no de forma limpia: una errata leve que la aplicación dejó pasar, una respuesta incorrecta enviada y corregida sobre la marcha, o una tan lenta que parece reconstruida más que recordada. Puede incluso que el ejercicio mostrara la respuesta por el camino: esta línea habla de lo que volvió, no de lo que hizo el ejercicio. Se queda por debajo de un recuerdo limpio, pero no cuenta como fallo.",
	hist_vtip_relearned: "La palabra se reconstruyó en lugar de recordarse: esta vez no salió sola, así que se le mostró y tuvo que volver a producirla. No se pierde nada y la planta nunca encoge: la palabra simplemente vuelve antes, y usted continúa desde donde estaba.",
	hist_vtip_early: "Practicó esta palabra antes de su fecha de riego y no falló. La práctica hecha por adelantado cuenta menos que la práctica hecha cuando a la palabra le toca: la planta aún puede subir de etapa si la memoria ha crecido lo suficiente, solo que hace falta más para lograrlo.",
	hist_vtip_sameDay: "Esta palabra volvió a aparecer a menos de unas seis horas de la última vez que contó: demasiado pronto para demostrar nada nuevo, así que no se midió nada y nada creció. La memoria crece en los intervalos entre prácticas, no dentro de una.",

	// ── Word statistics + one word's history ─────
	hist_ws_title: "Estadísticas de palabras",
	hist_ws_tooltip: "Todas las palabras practicadas con este par: cifras totales, tendencias y el historial propio de cada palabra",
	hist_ws_empty: "Aún no hay palabras practicadas para este par.",
	hist_ws_count: "{0} palabras · {1} dominadas",
	hist_ws_col_sessions: "Sesiones",
	hist_ws_col_trend: "Tendencia",
	hist_ws_col_mastered: "Dominadas",
	hist_ws_mastered_legend: "dominadas en al menos una sesión: son las que suman el número del recuadro",
	hist_ws_tip_word: "La palabra de esta fila. Haga clic en la fila para ver su historial completo.",
	hist_ws_tip_sessions: "Cuántas sesiones de práctica terminadas incluyeron esta palabra.",
	hist_ws_tip_shown: "Cuántas veces se presentó esta palabra para responder, en todas las sesiones.",
	hist_ws_tip_right: "Presentaciones respondidas correctamente, en todas las sesiones.",
	hist_ws_tip_wrong: "Presentaciones que terminaron con la respuesta a la vista: se agotó el tiempo o se pidió verla.",
	hist_ws_tip_accuracy: "Aciertos ÷ presentaciones, en todo el historial de la palabra.",
	hist_ws_tip_typical: "Su tiempo medio hasta un acierto en esta palabra, en todas las sesiones.",
	hist_ws_tip_trend: "Velocidad de respuesta, sesiones recientes frente a las anteriores. ▼ significa más rápido. Hacen falta varias sesiones cronometradas para que diga algo.",
	hist_ws_tip_mastered: "Llevada a término en al menos una sesión: acertada el número de veces requerido. Estas filas suman el recuadro de «palabras dominadas».",
	hist_ws_chart_speed: "Tiempo típico de respuesta por sesión",
	hist_ws_tip_chart_speed: "Cada punto es una sesión terminada: su tiempo típico (mediana por palabra) hasta un acierto. Una línea descendente significa que cada vez va más rápido.",
	hist_ws_chart_mastered: "Palabras dominadas con el tiempo",
	hist_ws_tip_chart_mastered: "Palabras dominadas, sumadas sesión a sesión.",
	hist_chart_few: "Aún no hay práctica suficiente aquí para dibujar el gráfico.",
	hist_wh_tip_dictionary: "Abrir la entrada completa del diccionario de esta palabra.",
	hist_wh_none: "Esta palabra aún no se ha practicado.",
	hist_wh_col_when: "Cuándo",
	hist_wh_tip_when: "La sesión que ejercitó esta palabra: su día y su hora de inicio. Haga clic en la fila para abrir esa sesión.",
	hist_wh_firstSeen: "Primera práctica",
	hist_wh_tip_firstSeen: "La primera sesión en la que apareció esta palabra.",
	hist_wh_lastSeen: "Última práctica",
	hist_wh_tip_lastSeen: "La sesión más reciente en la que apareció esta palabra.",
	hist_wh_stage: "Etapa de la planta",
	hist_wh_tip_stage: "La planta de esta palabra en su jardín: crece una etapa con cada repaso espaciado superado, hasta 7.",
	hist_wh_due: "Próximo riego",
	hist_wh_tip_due: "Cuándo prevé la aplicación volver a comprobar esta palabra. Los repasos se espacian cada vez más a medida que se afianza el recuerdo.",
	hist_wh_overdue: "atrasada",
	hist_wh_lapses: "Olvidos",
	hist_wh_article: "Artículo",
	hist_wh_articleNone: "ninguno escrito",
	hist_wh_tip_article: "Las veces que produjo esta palabra pero eligió el artículo equivocado. Cuentan como saber la palabra: lo que necesita práctica es el género, y el ejercicio de artículos se ocupa de eso.",
	hist_wh_tip_lapses: "Repasos en los que la palabra se había perdido y hubo que volver a aprenderla.",
	hist_wh_chart_speed: "Velocidad de respuesta",
	hist_wh_tip_chart_speed: "La línea es su tiempo típico hasta un acierto, por sesión. Los puntos pequeños son presentaciones sueltas. Una ✗ en la parte superior marca una presentación en la que hubo que revelar la respuesta.",
	hist_wh_chart_gaps: "Días entre prácticas",
	hist_wh_tip_chart_gaps: "El intervalo previo a cada práctica de esta palabra. Los intervalos crecientes indican un recuerdo más firme: la aplicación se atreve a esperar más y usted sigue recordando. La barra con contorno es el próximo repaso programado. La línea discontinua es lo que la aplicación había previsto en cada sesión: por encima de su barra significa que volvió antes de lo necesario.",
	hist_wh_scheduled: "programado",
	hist_wh_chart_stage: "Crecimiento de la planta",
	hist_wh_tip_chart_stage: "La etapa del jardín después de cada repaso contabilizado. Verde: el repaso se superó. Rojo: la palabra se olvidó y la planta retrocedió.",
	hist_wh_chart_acc: "Precisión por sesión",
	hist_wh_tip_chart_acc: "Aciertos ÷ presentaciones, en cada sesión que ejercitó esta palabra.",
	hist_wh_revealed: "revelada",
	hist_wh_pass: "superado",
	hist_wh_fail: "olvidado",
	// ── The accuracy root + the time root ─────────────────
	hist_acc_title: "Precisión",
	hist_acc_tooltip: "Cómo se forma su precisión y cómo cambia: sesión a sesión, y las palabras que la bajan",
	hist_acc_firstTry_lbl: "reconocidas a la primera",
	hist_acc_tip_accuracy: "Aciertos ÷ veces mostradas en todo lo practicado con este par: el mismo número que muestra el recuadro del panel.",
	hist_acc_tip_firstTry: "Palabras acertadas en su primerísima aparición, sobre el total de palabras que sus sesiones le han puesto delante. La diferencia con su precisión es lo que aporta el ejercitar en sí.",
	hist_acc_tip_chart_bySession: "Aciertos ÷ veces mostradas en cada sesión terminada, de la más antigua a la más reciente.",
	hist_acc_chart_firstTry: "Reconocidas a la primera por sesión",
	hist_acc_tip_chart_firstTry: "La proporción de palabras de cada sesión acertadas en su primerísima aparición: puro reconocimiento, antes de que ejercitar empiece a ayudar.",
	hist_acc_hard_head: "Palabras más difíciles ({0})",
	hist_acc_hard_sub: "menor precisión, entre las palabras mostradas al menos {0} veces: haga clic en una palabra para ver su historial completo",
	hist_acc_hard_none: "Ninguna palabra destaca: nada que se haya mostrado lo suficiente tiene una precisión baja.",
	hist_time_title: "Tiempo de estudio",
	hist_time_tooltip: "Adónde fue su tiempo de estudio: día a día, en total, y qué da de sí una hora de práctica",
	hist_time_typical_lbl: "sesión típica",
	hist_time_days_lbl: "días activos",
	hist_time_tip_total: "La duración de cada sesión terminada, sumada. Las pausas dentro de una sesión cuentan; el tiempo entre sesiones no.",
	hist_time_tip_sessions: "Sesiones de práctica terminadas con este par: el mismo recuento que el recuadro del panel.",
	hist_time_tip_typical: "La duración intermedia: la mitad de sus sesiones fueron más cortas y la otra mitad más largas, así que una noche maratónica no la distorsiona.",
	hist_time_tip_days: "Días con al menos una sesión terminada. El día se extiende hasta las 3:00 de la madrugada, así que una sesión de medianoche cuenta en el día anterior.",
	hist_time_fact_longest: "Sesión más larga",
	hist_time_tip_longest: "La sesión más larga de una sentada, y el día en que ocurrió.",
	hist_time_fact_perDay: "Promedio por día activo",
	hist_time_tip_perDay: "Tiempo total de estudio ÷ los días en que realmente practicó.",
	hist_time_fact_perWord: "Por palabra dominada",
	hist_time_tip_perWord: "Tiempo total de estudio ÷ palabras distintas dominadas: lo que cuesta una palabra que se queda. Que baje con el tiempo es la victoria.",
	hist_time_chart_byDay: "Tiempo de práctica por día",
	hist_time_tip_chart_byDay: "Minutos de práctica terminada en cada día de estudio: los huecos son días sin práctica.",
	hist_time_chart_total: "Horas totales a lo largo del tiempo",
	hist_time_tip_chart_total: "El tiempo de estudio sumado sesión a sesión. Un hábito constante se ve como una pendiente constante.",

	// ── "How does my garden grow?" (docs/project/garden-growth-explainer.md) ──
	garden_guide_title: "¿Cómo crece mi jardín?",
	garden_guide_open_chip: "¿Cómo crece mi jardín?",
	garden_guide_ladder_note: "Contando desde la primera práctica y con cada riego hecho a tiempo.",
	garden_guide_ready_note: "El primer paso, “Lista”, es una palabra que ya ha aprendido pero que todavía no ha practicado: el tallo ya asoma, pero no hay nada programado ni nada contando hasta su primera práctica.",
	garden_guide_lead: "Si la cuida bien, alrededor de medio año. Lo más rápido que puede lograrse son unos cuatro meses.",
	garden_guide_lead_v2: "Si la cuida bien, entre siete y nueve meses por lo general. Lo más rápido que puede lograrse, regando justo a tiempo en cada paso, son unos siete meses.",
	garden_guide_how: "Su planta crece un paso cada vez que la riega <em>cuando lo pide</em> y todavía recuerda la palabra. Las esperas entre riegos empiezan siendo mínimas y se alargan a medida que la palabra echa raíces: un día, unos días, una semana, dos semanas, un mes, dos meses. El halo brillante es el paso final, y significa una sola cosa: esta palabra sobrevivió un par de meses por su cuenta y usted seguía sabiéndola. Esas esperas suman unos cuatro meses incluso para una palabra que se le da sin esfuerzo, y alrededor de seis para una normal. Una palabra rebelde tarda lo que tenga que tardar; la aplicación seguirá trabajándola con usted.",
	garden_guide_how_v2: "Su planta crece un paso solo cuando vence su propia marca de crecimiento — <em>no por el mero hecho de haberla regado</em>. La memoria se fortalece en pasos que casi se duplican: cada vez que logra recordar una palabra tras una pausa más larga, la siguiente pausa puede ser sin riesgo casi el doble de larga, así que las marcas van subiendo: un día, tres días, una semana, dos semanas, un mes, dos meses, un trimestre. Un acierto poco antes de una marca también la da por cumplida: la ventana es corta, pero existe. El halo brillante es el paso final, y significa una sola cosa: esta palabra sobrevivió un trimestre entero por su cuenta y usted seguía sabiéndola. Esas marcas suman unos siete meses incluso para una palabra que supera todas justo a tiempo, y de siete a nueve para una normal, ya que una marca que se pasa simplemente espera al siguiente acierto, sin restarle nada a la palabra. Una palabra rebelde tarda lo que tenga que tardar; la aplicación seguirá trabajándola con usted.",
	garden_guide_twoThings: "Dos cosas que conviene saber:",
	garden_guide_hurryHead: "Regar más no lo acelera.",
	garden_guide_hurryBody: "Practicar una palabra diez veces más hoy no hace crecer nada: la aplicación ya sabe que la recuerda <em>hoy</em>. Lo que espera comprobar es si la recordará la semana que viene, y el mes que viene. La memoria crece en las pausas, y la planta lo muestra con honestidad.",
	garden_guide_forgetHead: "Olvidar no es ninguna catástrofe.",
	garden_guide_forgetBody: "Si una palabra se escapa, la planta nunca encoge: solo se pone sedienta 💧, vuelve antes y se retoma desde donde estaba.",
	garden_guide_closing: "Así que: plántela, riéguela cuando lo pida y espere el halo dentro de una o dos estaciones. No se puede apresurar, y justo por eso significa algo. Una flor brillante no es una medalla por pulsar botones; es la aplicación diciéndole: <em>esta palabra ya es suya, para siempre.</em>",
	garden_guide_closing_v2: "Así que: plántela, riéguela cuando lo pida y espere el halo dentro de dos o tres estaciones. No se puede apresurar, y justo por eso significa algo. Una flor brillante no es una medalla por pulsar botones; es la aplicación diciéndole: <em>esta palabra ya es suya, para siempre.</em>",
	garden_firstplant_card: "Su primera palabra acaba de brotar 🌱: vea cómo crece hasta convertirse en la flor radiante.",
	// The day badge's watering tooltip + the plant's click hint.
	garden_water_next: "Vuelva a regar esta palabra dentro de {0} — eso es lo que indica el número. Practicarla antes no hace crecer la planta más rápido.",
	garden_water_today: "Toca hoy — esta palabra está lista para regar. El punto permanece vacío hasta que acumule un día completo de retraso.",
	garden_water_overdue: "Con {0} de retraso — esta palabra está sedienta. No se pierde nada: la planta nunca se encoge, solo vuelve antes.",
	// P6 garden growth v2 surfaces (buckets, sprout, soft next-mark words, decision moment)
	garden_sprout_stage_name: "Brote",

	// Los ocho peldaños del crecimiento (garden.js). Términos alineados con el resto del
	// paquete: «dominado» como en hist_ws_count, «Brote» en el peldaño 0 de arriba.
	garden_ready_stage_name: "Listo",
	garden_stage1_name: "Visto una vez",
	garden_stage2_name: "Reconocido",
	garden_stage3_name: "Recordado",
	garden_stage4_name: "Echando raíces",
	garden_stage5_name: "Arraigado",
	garden_stage6_name: "Conocido",
	garden_stage7_name: "Dominado",
	// The next GROWTH mark, in soft words, appended to the watering badge's tooltip. Five spans
	// since 2026-08-25 (was three): everything past a fortnight used to collapse into "further
	// out", so 30 days and 90 days read the same and "not due to grow yet" looked like a repeated
	// non-answer. Words, never digits — that is what keeps this inside R38's "soft words only".
	// garden.js's SOFT_MARK_SPANS holds the cutoffs (3 / 14 / 45 / 75 days).
	garden_nextMark_fewDays: "Próxima revisión de crecimiento: dentro de unos días.",
	garden_nextMark_twoWeeks: "Próxima revisión de crecimiento: dentro de unas dos semanas.",
	garden_nextMark_month: "Próxima revisión de crecimiento: dentro de un mes, más o menos.",
	garden_nextMark_twoMonths: "Próxima revisión de crecimiento: dentro de unos dos meses.",
	garden_nextMark_fewMonths: "Próxima revisión de crecimiento: dentro de unos meses.",
	// ── the finish screen's three word groups (docs/project/finish-screen-classification.md) ──────
	// ONE axis: the verdict at the user's own strictness notch. The four R13 buckets are still what
	// the server sends and still decide the split INSIDE "Recalled"; they stopped being group names
	// because "Will grow soon" / "Needs sooner watering" describe what the app did, which the user
	// can check and disagree with, while the group is a claim about what they remembered.
	//
	// {1} in the two verdict heads is the linked word — main.js's exStrictnessHead splits the
	// formatted string there and drops an <a> in. Keep {1} in any translation, and inflect
	// exGroup_strictnessWord to match the case the sentence puts it in.
	exGroup_firstWatering: "Primer riego ({0})",
	// The one celebratory line on this card (owner, 2026-08-25). Deliberately says nothing about
	// pass or fail: a first practice is a first meeting, so there was nothing to recall yet.
	exGroup_firstWatering_note: "¡Felicidades: su primer riego! Estos tallos han echado raíces y han empezado a crecer.",
	exGroup_firstWatering_tooltip: "La primera vez que se practica una palabra, su tallo se convierte en una planta de verdad: entra en el calendario de riego y empieza a avanzar hacia su primera marca de crecimiento. Aquí no se juzga nada: una primera práctica es un primer encuentro, no una prueba de memoria.",
	exGroup_recalled: "Recordadas — según su {1} ({0})",
	exGroup_recalled_tooltip: "Produjo estas palabras al nivel que usted mismo fijó en el control de nivel de exigencia. Haga clic en las palabras para ver o cambiar dónde está ese listón: es lo único que decide en qué grupo cae cada palabra.",
	exGroup_notDueYet: "A la flor aún no le toca crecer ({0})",
	exGroup_notDueYet_tooltip: "Estas palabras volvieron, y a su flor sencillamente aún no le toca ninguna marca de crecimiento. Es lo normal, no una carencia: una planta crece cuando alcanza su propia marca siguiente —1, 3, 7, 14, 30, 60 o 90 días—, nunca porque una respuesta más fuera correcta.",
	exGroup_notRecalled: "No recordadas — según su {1} ({0})",
	exGroup_notRecalled_tooltip: "Estas palabras no volvieron al nivel que usted mismo fijó en el control de nivel de exigencia. No se pierde nada y ninguna planta encoge nunca: simplemente vuelven antes. Haga clic en las palabras para ver o cambiar dónde está ese listón.",
	exGroup_strictnessWord: "nivel de exigencia",
	exBucket_grew: "Crecieron hoy ({0})",
	exBucket_grew_tooltip: "Estas palabras alcanzaron hoy su siguiente marca de crecimiento: un día fijo en su propio calendario, ganado con una práctica real en esa fecha o después, nunca por la estimación de un modelo.",
	exBucket_multiStage: "subieron más de una etapa de una vez",
	decisionMoment_pileUp: "Esta semana toca mucho en comparación con su ritmo reciente. Puede dar algo más de tiempo a las sesiones, bajar un punto el nivel de exigencia o añadir palabras nuevas más despacio.",
	decisionMoment_headroom: "Su carga de práctica es ligera en comparación con su ritmo reciente: hay margen para añadir más palabras, subir un punto el nivel de exigencia o seguir sencillamente como hasta ahora.",
	garden_day_one: "día",
	garden_day_few: "días",
	garden_day_many: "días",
	garden_stats_click_hint: "Haga clic para ver las estadísticas de esta palabra",
	garden_forms_growing: "{0} formas creciendo",
	garden_grow_from: "etapa anterior: {0}",
	garden_grow_open: "Haga clic para ver todo su jardín",
	garden_vista_title: "Mi jardín",
	garden_vista_count: "{0} palabras plantadas",
	garden_vista_empty: "Aún no hay nada plantado: practique una palabra y aquí aparecerá su primer tallo.",
	garden_sr_edu: "💡 Regar dos veces al día no acelera el crecimiento: las plantas necesitan tiempo entre riegos.",
	garden_thirsty_chip: "{0} sedientas",
	garden_thirsty_tooltip: "Palabras a las que toca riego<p/>Haga clic para ponerlas en la bandeja de práctica",
	// Shown on EVERY press of the chip, not only when something new landed: a press that added
	// nothing (they were all staged already) used to answer with silence and read as a broken
	// button. The sentence is true either way, and it answers the question the press was asking.
	garden_thirstyStaged_toast: "¡Todas las plantas sedientas están en la bandeja, listas para regar!",
	garden_open_btn: "Mi jardín",
	garden_open_tooltip: "Todo su jardín de palabras: cada palabra plantada, en su etapa actual",
	garden_vista_click_hint: "Haga clic para ver la entrada completa",

	// ── Feedback: el diálogo 💬 (js/feedback.js). EN hasta que se haga una pasada en ES. ──
	feedback_menu: "Enviar comentarios",
	feedback_title: "Enviar comentarios",
	feedback_type_problem: "Problema",
	feedback_type_dislike: "No me gusta",
	feedback_type_like: "Me gusta",
	feedback_type_idea: "Sugerencia",
	feedback_type_question: "Pregunta",
	feedback_ph_start: "Elija una opción arriba y escriba su mensaje",
	feedback_ph_problem: "¿Qué salió mal?",
	feedback_ph_dislike: "¿Qué no le gusta?",
	feedback_ph_like: "¿Qué le gusta?",
	feedback_ph_idea: "¿Qué podría funcionar mejor?",
	feedback_ph_question: "¿Qué le gustaría saber?",
	feedback_email_label: "Correo para la respuesta (opcional)",
	feedback_send: "Enviar",
	feedback_cancel: "Cancelar",
	feedback_thanks: "¡Gracias! Leemos todos los mensajes.",

	// ── Owner-only word-decision audit table (session-word-audit.md) ──
	audit_title: "Auditoría de palabras",
	audit_none: "No se registró ninguna auditoría de esta sesión.",
	audit_empty: "Esta sesión no tiene palabras auditadas.",
	audit_finish_tooltip: "Solo propietario: el razonamiento completo de cada palabra de la sesión",
	audit_history_chip: "auditoría",
	audit_y_pass: "acierto",
	audit_y_fail: "fallo",
	audit_y_void: "nulo",
	audit_col_seq: "Sec",
	audit_col_outcome: "Resultado",
	audit_col_tier: "Nivel",
	audit_col_latency: "Latencia",
	audit_col_shownTs: "Mostrada",
	audit_outcome_PASS: "acierto",
	audit_outcome_FAIL: "fallo",
	audit_outcome_TIMEOUT: "tiempo agotado",
	audit_outcome_MEET: "conocer",
	audit_outcome_REVEAL: "revelar",
	audit_acol_attempt: "#",
	audit_acol_submitted: "Escrito",
	audit_acol_correct: "Correcto",
	audit_acol_similarity: "Sim",
	audit_acol_errorClass: "Error",
	audit_acol_firstKeyMs: "1.ª tecla",
	audit_acol_completionMs: "Finalización",
	audit_acol_allottedMs: "Asignado",
	audit_acol_keystrokes: "Teclas",
	audit_acol_backspaces: "Retroc",
	audit_yes: "Sí",
	audit_no: "No",
	audit_censored: "censurado",
	audit_group_label: "Etiqueta",
	audit_group_m5: "M5",
	audit_group_garden: "Jardín",
	audit_f_y: "y",
	audit_f_labelFlags: "Marcas",
	audit_f_nPres: "n presentaciones",
	audit_f_nMin: "n mín",
	audit_f_criterionMet: "Criterio cumplido",
	audit_f_g: "g",
	audit_f_gFinal: "g final",
	audit_f_epsilon: "Épsilon",
	audit_f_lStarMs: "L*",
	audit_f_sBefore: "S antes",
	audit_f_sAfter: "S después",
	audit_f_dAfter: "D después",
	audit_f_rHat: "R̂",
	audit_f_rStar: "R*",
	audit_f_intervalDays: "Δdías",
	audit_f_floored: "Truncado",
	audit_f_dueTs: "Toca",
	audit_f_algoVersion: "Versión del algoritmo",
	audit_f_decisionType: "Tipo de decisión",
	audit_f_stageBefore: "Etapa antes",
	audit_f_stageAfter: "Etapa después",
	audit_f_result: "Resultado",
	audit_f_wasDue: "Tocaba",
	audit_f_promoted: "Promovida",
	audit_f_planted: "Plantada",
	audit_f_grew: "Creció",
	audit_f_lapses: "Fallos",
	// The P4 shadow-verdict strip -- owner-only surface.
	audit_group_verdict: "Veredicto",
	audit_group_flower: "Flor",
	audit_decision_head: "Decisión",
	audit_f_notch: "Muesca",
	audit_f_band: "banda ≥",
	audit_f_showingsPlanned: "previstas",
	audit_f_bucket: "Grupo",
	audit_f_nextMarkDays: "Próxima marca (d)",
	audit_f_otherEngine: "El otro motor dijo",
	audit_f_dueModel: "Toca (modelo)",
	audit_f_nextShown: "Próxima aparición",
	audit_more_showings: "más apariciones tras el sellado — solo como prueba",
	audit_more_details: "Todo lo demás (apariciones completas, todas las muescas, bloques literales)",
	audit_lcol_showings: "Apariciones",
	audit_lcol_peeks: "Vistazos",
	audit_lcol_time: "Tiempo",
	audit_lcol_close: "Cercanía",
	audit_lcol_rstar: "r*",
	audit_lcol_flower: "Flor",
	audit_lcol_why: "Motivo",
	audit_words_count: "{0} palabras",
	audit_grid_mixed: " · muescas mixtas",
	audit_gate_perfect: "perfecta",
	audit_gate_off_peeks: "Solo la familia A (muescas 1–3) tiene presupuesto de vistazos.",
	audit_gate_off_time: "Solo observacional: la composición nunca lee el dial de tiempo. Real = peso de la muesca × latencia/tiempo asignado ({0}) de la aparición decisiva.",
	audit_gate_off_rstar: "M5 se programó con r* {0}; el objetivo por muesca permanece inactivo hasta el cambio P7.",
	audit_gate_off_close_c: "La familia C ignora la banda: el criterio es una aparición perfecta (≥ {0} nunca se lee).",
	audit_why_close: "por debajo de la banda en la aparición {0}",
	audit_why_peek: "vistazos por encima del presupuesto en la aparición {0}",
	audit_why_perfect: "no fue perfecta en la aparición {0}",
	audit_why_void: "sin sellar en ningún punto — {0} de {1} mostradas",
	audit_why_pass: "superada en la aparición {0}",
	audit_why_unknown: "sellada en la aparición {0} — familia no registrada",
	audit_v2_title: "v2 (en sombra)",
	audit_v2_sealedAt: "Sellada en",
	audit_v2_evid_col_seq: "#",
	audit_v2_evid_col_perfect: "Perfecta",
	audit_v2_evid_col_sim: "Sim. de prueba",
	audit_v2_evid_col_veto: "Veto",
	audit_v2_guardFlags: "Marcas de guarda",
	audit_v2_gradedCut: "Corte graduado",
	// The strictness slider's live caption
	strictness_captionN1: "Puede ver la respuesta hasta dos veces y luego escribirla de memoria: se admite una ortografía muy aproximada",
	strictness_captionN2: "Puede ver la respuesta una vez y luego escribirla de memoria: se admite una ortografía muy aproximada",
	strictness_captionN3: "Puede ver la respuesta una vez y luego escribirla de memoria: se admite una ortografía aproximada",
	strictness_captionN4: "Escriba la palabra aproximadamente bien antes de que se revele la respuesta, una vez",
	strictness_captionN5: "Escriba la palabra casi bien antes de que se revele la respuesta, dos veces",
	strictness_captionN6: "Escriba la palabra casi exactamente antes de que se revele la respuesta, dos veces",
	strictness_captionN7: "Escriba la palabra exactamente antes de que termine la cuenta regresiva, dos veces",
	strictness_captionN8: "Escriba la palabra exactamente antes de que termine la cuenta regresiva, tres veces",
	strictness_captionN9: "Escriba la palabra exactamente antes de que termine la cuenta regresiva, tres veces seguidas",
	strictness_captionN10: "Escriba la palabra exactamente antes de que termine la cuenta regresiva, siempre, sin excepción: sin ninguna ayuda",
	// Part-of-speech labels (pos_label.js) -- pos_label.js real.
	posNoun_label: "sust",
	posNoun_tooltip: "sustantivo",
	posVerb_label: "verbo",
	posVerb_tooltip: "verbo",
	posAdjective_label: "adj",
	posAdjective_tooltip: "adjetivo",
	posAdverb_label: "adv",
	posAdverb_tooltip: "adverbio",
	posPhrase_label: "expr",
	posPhrase_tooltip: "expresión",
	posPhraseVerbConj_label: "vconj",
	posPhraseVerbConj_tooltip: "forma verbal conjugada",
	posVerbForms_label: "formas",
	posVerbForms_tooltip: "formas principales del verbo",
	posPreposition_label: "prep",
	posPreposition_tooltip: "preposición",
	posPronoun_label: "pron",
	posPronoun_tooltip: "pronombre",
	posConjunction_label: "conj",
	posConjunction_tooltip: "conjunción",
	posInterjection_label: "interj",
	posInterjection_tooltip: "interjección",
	posNumeral_label: "num",
	posNumeral_tooltip: "numeral",
	posArticle_label: "art",
	posArticle_tooltip: "artículo",
	posDeterminer_label: "det",
	posDeterminer_tooltip: "determinante",
	posAbbreviation_label: "abrev",
	posAbbreviation_tooltip: "abreviatura",
	posParticle_label: "part",
	posParticle_tooltip: "partícula",
	posPrefix_label: "pref",
	posPrefix_tooltip: "prefijo",
	// Form kinds (word_form rows) -- pos_label.js real.
	posPlural_label: "pl",
	posPlural_tooltip: "plural",
	posGenitiveSg_label: "gen",
	posGenitiveSg_tooltip: "genitivo singular",
	posDeclined_label: "decl",
	posDeclined_tooltip: "forma declinada",
	posPast_label: "pas",
	posPast_tooltip: "tiempo pasado",
	posPreterite_label: "pret",
	posPreterite_tooltip: "pretérito (pasado simple)",
	posPastParticiple_label: "part",
	posPastParticiple_tooltip: "participio pasado",
	posPresent1Sg_label: "1sg",
	posPresent1Sg_tooltip: "presente, 1.ª persona del singular",
	posPresent2Sg_label: "2sg",
	posPresent2Sg_tooltip: "presente, 2.ª persona del singular",
	posPresent3Sg_label: "3sg",
	posPresent3Sg_tooltip: "presente, 3.ª persona del singular",
	posImperative_label: "imper",
	posImperative_tooltip: "imperativo",
	posSubjunctiveII_label: "subj2",
	posSubjunctiveII_tooltip: "subjuntivo II",
	posSeparableParticle_label: "sep",
	// English placeholder, tracking resources_en.js — ⛔ was 'separable prefix', which named the
	// wrong half of the verb (the row is the finite verb form, not the prefix).
	posSeparableParticle_tooltip: "forma separable",
	posComparative_label: "comp",
	posComparative_tooltip: "comparativo",
	posSuperlative_label: "sup",
	posSuperlative_tooltip: "superlativo",
	posIngForm_label: "-ing",
	posIngForm_tooltip: "forma en -ing",
	posContraction_label: "contr",
	posContraction_tooltip: "contracción",
	posSuppletive_label: "supl",
	posSuppletive_tooltip: "forma supletiva",
	posProperNoun_label: "prop",
	posProperNoun_tooltip: "nombre propio",
	posSpellingVariant_label: "var",
	posSpellingVariant_tooltip: "variante ortográfica",
	posFusion_label: "fus",
	posFusion_tooltip: "forma fusionada",
	posOther_label: "otro",
	posOther_tooltip: "otro"
};
